window.app = window.app || {};
window.app.enterprise_geodata =  {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "id": "I-1d-1",
            "properties": {
                "name": "I-1d-1 COPAL",
                "gateway": [ 311.0625,787.125 ],
                "data": {
                    "ID": 76,
                    "TenDoanhNghiep": "Công ty TNHH Nidec Copal Precision Việt Nam",
                    "GoiTat": "NCVP",
                    "QuocGia": "Nhật Bản",
                    "DaiDienPhapLuat": "Ông Takehiko Kumagai - Tổng Giám đốc",
                    "LinhVucHoatDong": "Cơ khí chính xác và tự động hóa",
                    "TenDuAnDauTu": "Công ty TNHH Nidec Copal Precision Việt Nam​",
                    "MucTieuQuyMoDuAn": [
                        "Thiết kế, sản xuất và kinh doanh các loại mô tơ compact có độ chính xác cao và các linh phụ kiện của mô tơ với quy mô:",
                        "-   Giai đoạn  đầu (2010 - 2012): 13.656.000 mô tơ + 1.050.000 linh kiện",
                        "-   Giai đoạn ổn định (từ 2012 trở đi): 217.844.000 mô tơ + 29.720.000 linh kiện"
                    ],
                    "DiaChiTrongKhu": "Lô I-1d-1, đường N1",
                    "DienThoai": "37361111",
                    "Fax": "37360943",
                    "Website": "http://www.nidec-copal.com/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
[[325.3125,762.625],[313.1875,768.375],[313.9375,773.625],[313.5625,778.875],[311.6875,786.625],[308.8125,793.5],[301.8125,803.5],[341.5625,822.75],[361.0625,812.75],[369.9375,807.25],[325.3125,762.625]]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "I3-9",
            "properties": {
                "name": "COPAL-2",
                "gateway": [  436.9375,654.375 ],
                "data": {
                    "ID": 67,
                    "TenDoanhNghiep": "Công ty TNHH Sonion Việt Nam",
                    "GoiTat": "Sonion Vietnam",
                    "QuocGia": "Đan Mạch",
                    "DaiDienPhapLuat": "Ông Torben Axelsen - Tổng Giám Đốc",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Công ty TNHH Sonion Việt Nam​",
                    "MucTieuQuyMoDuAn": [
                        "Sản xuất các sản phẩm và công nghệ âm thanh siêu nhỏ và vi cơ điện tử, phát triển và sản xuất micrô bằng vi cơ điện tử silicon (micrô, ống nghe và loa)."
                    ],
                    "DiaChiTrongKhu": "Lô I3-9",
                    "DienThoai": "37362222",
                    "Fax": "37360525",
                    "Website": "http://www.sonion.com",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 432.125, 658 ],
                        [ 457.625, 641.25 ],
                        [ 471.875, 652 ],
                        [ 447.125, 669.5 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "I-10.1",
            "properties": {
                "name": "I-10.1",
                "gateway": [ 524.4375,359.75 ],
                "data": {
                    "ID": 18,
                    "TenDoanhNghiep": "Công ty TNHH CNS Amura Precision",
                    "GoiTat": "CNS Amura",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Hồ Minh Sơn - Tổng Giám đốc",
                    "LinhVucHoatDong": "Cơ khí chính xác và tự động hóa",
                    "TenDuAnDauTu": "Thiết kế, chế tạo sản phẩm cơ khí chính xác cao​​​",
                    "MucTieuQuyMoDuAn": [
                        "Nghiên cứu, ứng dụng công nghệ mới để thiết kế, chế tạo sản phẩm cơ khí đạt tiêu chuẩn chính xác cao nhằm cung cấp sản phẩm cho các đơn vị trong Tổng công ty, chó các nhà đầu tư trong lĩnh vực công nghệ cao trong nước và tiến đến xuất khẩu sang các nước khác​"
                    ],
                    "DiaChiTrongKhu": "Lô I-10-1, Đường D2",
                    "DienThoai": "62577598",
                    "Fax": "38953347",
                    "Website": "http://cnsamura.com.vn/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 465.125, 394.1000003814697 ],
                        [ 470.125, 404.6000003814697 ],
                        [ 474.375, 410.8500003814697 ],
                        [ 478.375, 413.6000003814697 ],
                        [ 530.625, 365.8500003814697 ],
                        [ 518.875, 354.3500003814697 ],
                        [ 512.875, 358.6000003814697 ],
                        [ 504.625, 352.3500003814697 ],
                        [ 472.125, 388.8500003814697 ],
                        [ 464.375, 390.8500003814697 ],
                        [ 465.125, 394.1000003814697 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "I-10.2",
            "properties": {
                "name": "I-10.2",
                "gateway": [ 542.96875,379.0625 ],
                "data": {
                    "ID": 24,
                    "TenDoanhNghiep": "Công ty TNHH Đầu tư nhà xưởng Lập Thành",
                    "GoiTat": "LTF Co., Ltd",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Nguyễn Anh Tuấn - Chủ tịch HĐTV",
                    "LinhVucHoatDong": "Dịch vụ thương mại",
                    "TenDuAnDauTu": "Dự án Đầu tư xây dựng Nhà xưởng cho thuê tại Khu Công nghệ cao​​",
                    "MucTieuQuyMoDuAn": [
                        "a) Mục tiêu:",
                        "- Đầu tư xây dựng nhà xưởng xây sẵn và nhà xưởng xây theo yêu cầu với diện tích vừa và nhỏ (tứ 1.000m2 đến 5.000m2), với mức giá cho thuê cạnh tranh và thời hạn cho thuê linh hoạt, đáp ứng nhu cầu của những DN đầu tư trong KCNC, bao gồm: DN sản xuất CNC, DN nghiên cứu phát triển, DN công nghiệp hỗ trợ CNC,...",
                        "- Cung cấp dịch vụ bảo trì, sửa chữa nhà xưởng, ​hệ thống điện, nước, CN xây dựng phù hợp cho đối tượng khách hàng và nhu cầu sử dụng.",
                        "b) Quy mô:",
                        "Xây dựng tổng cộng 18 nhà xưởng với tổng diện tích sàn xây dựng dự kiến là 27.106 m2."
                    ],
                    "DiaChiTrongKhu": "Lô I-10-2, Đường D2​",
                    "DienThoai": "39979871",
                    "Fax": "39979873",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 479.125, 414.3500003814697 ],
                        [ 489.625, 421.8500003814697 ],
                        [ 493.375, 422.3500003814697 ],
                        [ 508.125, 410.6000003814697 ],
                        [ 515.125, 405.6000003814697 ],
                        [ 523.875, 400.6000003814697 ],
                        [ 543.125, 394.6000003814697 ],
                        [ 551.375, 392.6000003814697 ],
                        [ 553.125, 390.1000003814697 ],
                        [ 530.875, 366.3500003814697 ],
                        [ 479.125, 414.3500003814697 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "I-10.6",
            "properties": {
                "name": "I-10.6",
                "gateway": [ 501.4375, 416 ],
                "data": {
                    "ID": 8,
                    "TenDoanhNghiep": "Công ty Cổ phần Kỹ thuật công nghệ tự động Hải Nam",
                    "GoiTat": "Hải Nam",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Ngô Hiếu Hải - Giám đốc",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Hệ thống giám sát và điều khiển Hải Nam",
                    "MucTieuQuyMoDuAn": [
                        "- Nghiên cứu, thiết kế và chế tạo: Linh kiện và cụm thiết bị đo lường, điều khiển, giám sát, tự động hóa và phân phối điện cho các hệ thống thiết bị đồng bộ phục vụ công nghiệp công nghệ cao (nhà máy chế tạo linh kiện bán dẫn, điện tử, sản xuất tấm pin mặt trời), các ngành công nghiệp khác, năng lượng (nhà máy điện, nhà máy lọc hóa dầu) và cơ sở hạ tầng (sân bay, cảng biển, metro, công trình dân dụng)",
                        "- Nghiên cứu, thiết kế chế tạo và tích hợp các loại sản phẩm cấu thành: Hệ thống giám sát, điều khiển, thu thập dữ liệu (SCADA) cho lưới điện như MCC, PLC, DCS và phần mềm tích hợp cũng như các loại rơ–le kỹ thuật số cho hệ thống điện",
                        "- Cung cấp sản phẩm và dịch vụ hỗ trợ trọn gói (lắp đặt, đào tạo, vận hành, bảo trì) phục vụ các nhà máy công nghệ cao hiện đang hoạt động tại Việt Nam: Cung cấp hệ thống trung tâm điều khiển động cơ thông minh (iMCC) và các loại tủ điều khiển, phân phối điện cho các công ty kỹ thuật cao, các ngành công nghiệp, năng lượng và cơ sở hạ tầng; cung cấp các sản phẩm và dịch vụ hỗ trợ phục vụ cho các khách hàng trên trong công tác bảo trì, nâng cấp, mở rộng sau này; Hợp tác cung cấp sản phẩm phần mềm và dịch vụ bảo trì toàn diện cho khách hàng. Khách hàng mục tiêu: các công ty hoạt động đa lĩnh vực (gồm có: công nghệ thông tin, bảo hiểm, dầu khí, thương mại, bán lẻ…) trong nước và trên thế giới, đặc biệt là thị trường Đông Nam Á"
                    ],
                    "DiaChiTrongKhu": "Lô I–10–6, Đường D7",
                    "DienThoai": "38389868",
                    "Fax": "",
                    "Website": "http://www.indigo-jsc.com/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 490.0625, 421.875 ],
                        [ 493.0625, 422 ],
                        [ 500.0625, 416.5 ],
                        [ 505.1875, 412.375 ],
                        [ 508.9375, 409.5 ],
                        [ 512.0625, 407.625 ],
                        [ 499.1875, 395.375 ],
                        [ 479.3125, 414.25 ],
                        [ 490.0625, 421.875 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "I1-N1",
            "properties": {
                "name": "I1-N1 NIDEC-SANKYO",
                "gateway": [ 267.4375, 833.875 ],
                "data": {
                    "ID": 73,
                    "TenDoanhNghiep": "Công ty TNHH Nidec Sankyo Việt Nam",
                    "GoiTat": "NSVC",
                    "QuocGia": "Nhật Bản",
                    "DaiDienPhapLuat": "Ông Shimada Hidetoshi - Tổng Giám Đốc",
                    "LinhVucHoatDong": "Cơ khí chính xác và tự động hóa",
                    "TenDuAnDauTu": "Công ty TNHH Nidec Sankyo Việt Nam​",
                    "MucTieuQuyMoDuAn": [
                        "- Sản xuất và tiêu thụ các linh kiện đầu gắp quang học; động cơ bước, các thiết bị điện gia dụng cao cấp sử dụng động cơ bước; Đầu đọc thẻ từ tính; đầu đọc thẻ trả trước; công tắc định giờ; và chế tạo các linh kiện máy móc để sản xuất các sản phẩm trên.",
                        "- Quy mô : Số lượng 150.000.000 (một trăm năm mươi triệu) cái/năm."
                    ],
                    "DiaChiTrongKhu": "Lô I1-N1",
                    "DienThoai": "37360014",
                    "Fax": "37360018",
                    "Website": "http://www.nidec-sankyo.co.jp/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 234, 798.375 ],
                        [ 281.5, 818.625 ],
                        [ 257.5, 844.625 ],
                        [ 210.75, 825.125 ]
                    ]
                ]
            }
        },

        {
            "type": "Feature",
            "id": "NIDEC-VIETNAM",
            "properties": {
                "name": "NIDEC-VIETNAM",
                "gateway": [ 265.59375,744.4375 ],
                "data": {
                    "ID": 75,
                    "TenDoanhNghiep": "Công ty TNHH Nidec Việt Nam Corporation",
                    "GoiTat": "NCVH",
                    "QuocGia": "Nhật Bản",
                    "DaiDienPhapLuat": "Ông Masahiko Miyano - Tổng Giám Đốc",
                    "LinhVucHoatDong": "Cơ khí chính xác và tự động hóa",
                    "TenDuAnDauTu": "Công ty TNHH Nidec Việt Nam Corporation​",
                    "MucTieuQuyMoDuAn": [
                        "100.000.000 sản phẩm/năm, sản phẩm xuất khẩu 100% đến năm 2010​"
                    ],
                    "DiaChiTrongKhu": "Lô I1-N2",
                    "DienThoai": "37360075",
                    "Fax": "37360073",
                    "Website": "http://www.nidec.com/en-Global/corporate/network/nidec/vietnam/vietnam_p/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 239.5, 749.375 ],
                        [ 294.75, 738.875 ],
                        [ 298, 739.875 ],
                        [ 307.75, 763.875 ],
                        [ 251.5, 775.375 ],
                        [ 251.25, 765.875 ],
                        [ 249, 761.125 ],
                        [ 245, 758.875 ],
                        [ 239.5, 749.375 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "I2",
            "properties": {
                "name": "INTEL-PRODUCTS-VN",
                "gateway": [
                    345.0625,
                    716.9375
                ],
                "data": {
                    "ID": 30,
                    "TenDoanhNghiep": "Công ty TNHH Intel Products Việt Nam",
                    "GoiTat": "",
                    "QuocGia": "Hà Lan",
                    "DaiDienPhapLuat": "Bà Sherry Sheno Boger - Tổng Giám đốc",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Công ty TNHH Intel Products Việt Nam​",
                    "MucTieuQuyMoDuAn": [
                        "- Hoàn chỉnh và sản xuất các sản phẩm chíp mang nhãn hiệu Intel từ màng mạch (wafer).",
                        "- Tiếp thị những sản phẩm của DN tại thị trường VN và nước ngoài.",
                        "- Cung cấp dịch vụ hậu mãi và hỗ trợ các sản phẩm mang nhãn hiệu Intel (bao gồm việc lập các trung tâm điện thoại hỗ trợ miễn phí và trung tâm bảo hành sản phẩm cho khách hàng).",
                        "- Thực hiện nghiên cứu phát triển trong các lĩnh vực thông tin kỹ thuật cao (bao gồm nghiên cứu CN cho thương mại điện tử).",
                        "- Thực hiện hoạt động kiểm tra, kiểm nghiệm sản phẩm; cung cấp các dịch vụ kỹ thuật liên quan đến hoạt động DN như lắp đặt, bảo trì, tư vấn, đào tạo và các giải pháp kỹ thuật cho các sản phẩm mang nhãn hiệu Intel.​"
                    ],
                    "DiaChiTrongKhu": "Lô I2",
                    "DienThoai": "37366200",
                    "Fax": "37360510",
                    "Website": "http://www.intel.vn/content/www/vn/vi/homepage.html",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[418.0625,668],[461.0625,699.625],[497.8125,675.5],[530.4375,701.375],[370.0625,807],[302.3125,738.75],[302.9375,736.875],[308.1875,736],[316.8125,733.625],[324.1875,730.625],[330.6875,727.25],[337.0625,723.25],[348.1875,715.25],[361.4375,706],[376.1875,696.5],[418.0625,668]]]
            }
        },
        {
            "type": "Feature",
            "id": "I-1d-2",
            "properties": {
                "name": "I-1d-2 NIDEC-SEIMTTBU",
                "gateway": [ 289.8125, 815.375 ],
                "data": {
                    "ID": 74,
                    "TenDoanhNghiep": "Công ty TNHH Nidec Seimitsu Việt Nam",
                    "GoiTat": "NSTV",
                    "QuocGia": "Nhật Bản",
                    "DaiDienPhapLuat": "Ông Kitazawa Takami",
                    "LinhVucHoatDong": "Cơ khí chính xác và tự động hóa",
                    "TenDuAnDauTu": "Nidec Seimitsu Việt Nam",
                    "MucTieuQuyMoDuAn": [
                        "- Phát triển, SX và kinh doanh các sản phẩm mô tơ siêu nhỏ.",
                        "- Quy mô:",
                        "+ Giai đoạn đầu (6 tháng từ khi đi vào hoạt động): 15 triệu sản phẩm/năm.",
                        "+ Giai đoạn ổn định (3 năm sau khi đi vào hoạt động): 40 triệu sản phẩm/tháng.​"
                    ],
                    "DiaChiTrongKhu": "Lô I-1d-2, đường N1",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "http://www.nidec-seimitsu.com/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 301.75, 804.125 ],
                        [ 280.5, 827.125 ],
                        [ 305.25, 839.125 ],
                        [ 323.25, 836.375 ],
                        [ 341, 822.625 ],
                        [ 301.75, 804.125 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "I1.3-N1",
            "properties": {
                "name": "I1.3-N1",
                "gateway": [ 290.1875, 809.875 ],
                "data": {
                    "ID": 66,
                    "TenDoanhNghiep": "Công ty TNHH Nidec Servo Việt Nam",
                    "GoiTat": "NSVT",
                    "QuocGia": "Nhật Bản",
                    "DaiDienPhapLuat": "Ông Hiroki Shimomura - Tổng Giám Đốc",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Công ty TNHH Nidec Servo Việt Nam​",
                    "MucTieuQuyMoDuAn": [
                        "- Chế tạo động cơ chính xác nhỏ và bộ phận dùng cho thiết bị tự động văn phòng, thiết bị công nghiệp, máy trả tiền tự động (máy ATM), máy ảnh kiểm tra, hệ thống chiếu sáng, bơm, bộ phận thẩm thấu nhân tạo, điện liệu pháp trong y học, thiết bị giải trí.",
                        "- Quy mô: 24.000.000 (hai mươi bốn triệu) đơn vị sản phẩm/ năm (từ năm 2012).​​"
                    ],
                    "DiaChiTrongKhu": "Lô I1.3-N1",
                    "DienThoai": "37360912",
                    "Fax": "37360925",
                    "Website": "http://www.nidec-servo.com/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [ 
                [[274.1875,785.125],[306.0625,787.875],[306.9375,784.875],[308.0625,779.875],[308.6875,774.875],[308.4375,769.25],[307.5625,764.75],[251.6875,775.5],[250.5625,781],[249.1875,785.125],[245.9375,789.25],[239.8125,796.5],[237.0625,798.375],[234.0625,799],[280.9375,818.875],[296.4375,802.75],[298.5625,800.125],[300.6875,797.125],[274.1875,785.125]]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "K02",
            "properties": {
                "name": "K02",
                "gateway": [ 438.78125,669.125 ],
                "data": {
                    "ID": 10,
                    "TenDoanhNghiep": "Công ty Cổ phần SX DV Công nghệ Bán dẫn Toàn cầu VN",
                    "GoiTat": "GES",
                    "QuocGia": "Mỹ",
                    "DaiDienPhapLuat": "Ông Ng Seo Ping - Tổng Giám đốc",
                    "LinhVucHoatDong": "Dịch vụ CNC",
                    "TenDuAnDauTu": "Trung tâm kỹ nghệ bán dẫn GES",
                    "MucTieuQuyMoDuAn": [
                        "- Nghiên cứu và sản xuất các thiết bị bán dẫn, sữa chữa các trang thiết bị của ngành công nghiệp bán dẫn. Quy mô: 200 đơn vị thiết bị và cụm máy móc kèm theo/năm.",
                        "- Thiết kế lắp đặt bảo trì bảo hành hệ thống sử dụng năng lượng mặt trời và năng lượng tái tạo.​​"
                    ],
                    "DiaChiTrongKhu": "Lô I3-1, đường D1",
                    "DienThoai": "37306032",
                    "Fax": "37306242",
                    "Website": "http://www.geservs.com/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 417.25, 667.875 ],
                        [ 426.25, 661.875 ],
                        [ 428.25, 661.375 ],
                        [ 440.5, 670.375 ],
                        [ 431.5, 677.875 ],
                        [ 417.25, 667.875 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "K03",
            "properties": {
                "name": "K03",
                "gateway": [ 446.265625,674.46875 ],
                "data": {
                    "ID": 26,
                    "TenDoanhNghiep": "Công ty TNHH Điện tử D.G.S",
                    "GoiTat": "D.G.S",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Hà Minh Trường - Chủ tịch HĐQT, Tổng Giám đốc",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Đầu tư xây dựng Dây chuyền thiết kế, gia công, sản xuất xuất khẩu bộ cảm biến kỹ thuật số và các loại thiết bị điện tử​",
                    "MucTieuQuyMoDuAn": [
                        "- Thiết kế, gia công, sản xuất xuất khẩu bộ cảm biến kỹ thuật số và các loại thiết bị điện tử.",
                        "- Quy mô: năm sản xuất ổn định (năm thứ 3 kể từ khi hoạt động): công suất 2 triệu môđun​"
                    ],
                    "DiaChiTrongKhu": "Lô I3-2, Đường N2",
                    "DienThoai": "37360721",
                    "Fax": "37360722",
                    "Website": "http://www.digisensor-ltd.com/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [[431.640625,677.84375],[440.515625,670.46875],[452.390625,679.34375],[443.203125,686.28125],[431.640625,677.84375]]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "K04.1",
            "properties": {
                "name": "K04.1",
                "gateway": [ 456.265625,681.875 ],
                "data": {
                    "ID": 2,
                    "TenDoanhNghiep": "Công ty Cổ phần Thông Minh MK",
                    "GoiTat": "",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Nguyễn Hải Hà - Tổng Giám đốc",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Trung tâm cá thể hóa, nghiên cứu và phát triển thẻ thông minh MK Smart​",
                    "MucTieuQuyMoDuAn": [
                        "- Tham gia hình thành cụm thẻ thông minh.",
                        "- Mở rộng sản xuất và dịch vụ cá thể hóa thẻ thông minh theo chuẩn quốc gia và quốc tế.​​",
                        "- Phát ​triển kinh doanh thẻ và giải pháp thẻ khu vực miền Nam Việt Nam và các nước lân cận.",
                        "- Cung cấp dịch vụ gia công các quy trình công nghệ.",
                        "- Tăng cường nghiên cứu & phát triển CN, phát triển phần mềm và ứng dụng thẻ thông minh hỗ trợ tốt nhất cho sản xuất, phục vụ nhu cầu thẻ nội địa và quốc tế."
                    ],
                    "DiaChiTrongKhu": "Lô I3-3, Đường N2",
                    "DienThoai": "39320627",
                    "Fax": "39321287",
                    "Website": "http://mksmart.com.vn/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 450, 691.375 ],
                        [ 443.75, 686.375 ],
                        [ 452.5, 679.375 ],
                        [ 459.75, 684.125 ],
                        [ 450, 691.375 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "K04.2",
            "properties": {
                "name": "K04.2",
                "gateway": [ 456.265625,681.875 ],
                "data": {
                    "ID": 12,
                    "TenDoanhNghiep": "Chi nhánh Công ty Cổ phần Tập đoàn MK",
                    "GoiTat": "MK Branch JSC",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Đỗ Hải Đăng - Giám đốc",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Trung tâm nghiên cứu, phát triển, sản xuất và cá thể hóa thẻ thông minh MK​​",
                    "MucTieuQuyMoDuAn": [
                        "- Sản xuất thẻ thông minh và các loại thẻ (thẻ nhựa, thẻ từ, thẻ chíp, thẻ dữ liệu...).",
                        "- Nghiên cứu và phát triển thẻ thông minh.",
                        "- Cung cấp dịch vụ công nghệ cao như: sản xuất phần mềm; tư vấn về chuyển giao công nghệ; cung cấp các dịch vụ liên quan đến."
                    ],
                    "DiaChiTrongKhu": "Lô I3-3, đường N2",
                    "DienThoai": "37361445",
                    "Fax": "",
                    "Website": "http://www.mk.com.vn",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 450, 691.375 ],
                        [ 443.75, 686.375 ],
                        [ 452.5, 679.375 ],
                        [ 459.75, 684.125 ],
                        [ 450, 691.375 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "K05",
            "properties": {
                "name": "K05",
                "gateway": [465.328125,680.609375],
                "data": {
                    "ID": 13,
                    "TenDoanhNghiep": "Công ty Cổ phần Vi mạch Điện tử Việt Vmicro",
                    "GoiTat": "Vmicro",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Bà Trần Thị Lâm - Chủ tịch HĐQT",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Nhà máy SX vi mạch điện tử và pin năng lương mặt trời Việt Vmicro​",
                    "MucTieuQuyMoDuAn": [
                        "Sản xuất và nghiên cứu thiết kế các loại linh kiện thiết bị bán dẫn sản xuất các loại sản phẩm thiết bị năng lượng mặt trời​"
                    ],
                    "DiaChiTrongKhu": "Lô I3-4, đường số N2",
                    "DienThoai": "38221745",
                    "Fax": "",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 450.25, 691.625 ],
                        [ 460.75, 699.875 ],
                        [ 478, 688.375 ],
                        [ 466.75, 680.125 ],
                        [ 450.25, 691.625 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "K06",
            "properties": {
                "name": "K06",
                "gateway": [ 495.203125,675.40625 ],
                "data": {
                    "ID": 69,
                    "TenDoanhNghiep": "Cty TNHH MTV QSIC Việt Nam",
                    "GoiTat": "QSIC Vietnam Co., Ltd",
                    "QuocGia": "Mỹ",
                    "DaiDienPhapLuat": "Ông Kiem Le Tinh - Tổng Giám đốc",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Cty TNHH MTV QSIC Việt Nam​",
                    "MucTieuQuyMoDuAn": [
                        "- Thiết kế, sản xuất và lắp ráp các linh kiện phụ tùng cho các thẻ modem của thiết bị không dây, truyền hình có độ phân giải cao (HDTV); sản phẩm dùng trong hệ thống định vị toàn cầu; sản phẩm dùng cho máy in; các thiết bị tự động dùng cho văn phòng; sản phẩm hóa sinh (thiết bị y sinh); sản phẩm phục vụ hệ thống mạng và mạng không dây; sản phẩm điện tử tiêu dùng và điện tử phục vụ chuyên ngành.​",
                        "- Cung cấp các dịch vụ cho các sản phẩm do công ty sản xuất."
                    ],
                    "DiaChiTrongKhu": "Lô I3-6, Đường N2",
                    "DienThoai": "37361035",
                    "Fax": "",
                    "Website": "http://www.qsic.com/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 497.75, 675.875 ],
                        [ 478, 688.125 ],
                        [ 467, 680.125 ],
                        [ 481.25, 670.125 ],
                        [ 485.75, 672.625 ],
                        [ 491.25, 674.875 ],
                        [ 497.75, 675.875 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "I-3b-5",
            "properties": {
                "name": "I-3b-5",
                "gateway": [520.359375,688 ],
                "data": {
                    "ID": 55,
                    "TenDoanhNghiep": "Viện Vật liệu xậy dựng - Bộ Xây dựng",
                    "GoiTat": "",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Lương Đức Long - Viện trưởng",
                    "LinhVucHoatDong": "Năng lượng, vật liệu mới",
                    "TenDuAnDauTu": "Trung tâm Nghiên cứu vật liệu mới thuộc Viện Vật liệu xây dựng tại Miền Nam​",
                    "MucTieuQuyMoDuAn": [
                        "Xây dựng trung tâm nghiên cứu vật liệu mới nhằm nâng cao năng lực nghiên cứu phát triển các loại vật liệu mới của Viện Vật liệu xây dựng tại Miền Nam theo chức năng và nhiệm vụ được giao, đáp ứng nhu cầu phát triển vật liệu mới, tiên tiến cho khu vực TP.HCM và các tỉnh phía Nam"
                    ],
                    "DiaChiTrongKhu": "Lô I-3b-5, đường N6",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "http://www.vibm.vn/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 529.1875, 673.125 ],
                        [ 536.9375, 676.25 ],
                        [ 542.4375, 681.375 ],
                        [ 526.3125, 692.5 ],
                        [ 513.9375, 683 ],
                        [ 529.1875, 673.125 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "I-3b-4",
            "properties": {
                "name": "I-3b-4",
                "gateway": [ 511.2890625,681.0703125 ],
                "data": {
                    "ID": 25,
                    "TenDoanhNghiep": "Công ty TNHH Đầu tư và phát triển Công nghệ thông minh",
                    "GoiTat": "Đầu tư và Phát triển Công nghệ thông minh (STID)",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Lê Văn Giảng - Giám đốc",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Sản xuất thẻ thông minh​",
                    "MucTieuQuyMoDuAn": [
                        "- Đầu tư dây chuyền sản xuất thẻ thông minh.",
                        "- Quy mô: 200 triệu thẻ cào/năm; 3 triệu thẻ sim/năm​ (năm sản xuất ổn định: năm thứ 3)."
                    ],
                    "DiaChiTrongKhu": "Lô I-3b-4 (tên cũ là lô K2-b)",
                    "DienThoai": "",
                    "Fax": "38309056",
                    "Website": "http://www.vtctelecom.com.vn/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 509.4375, 677.875 ],
                        [ 523.4375, 668.875 ],
                        [ 529.0625, 673 ],
                        [ 513.9375, 682.75 ],
                        [ 509.3125, 679.625 ],
                        [ 509.4375, 677.875 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "I-3b-3",
            "properties": {
                "name": "I-3b-3",
                "gateway": [ 547.59375,653.4375 ],
                "data": {
                    "ID": 61,
                    "TenDoanhNghiep": "Trung tâm Thiết kế Chế tạo Thiết bị mới",
                    "GoiTat": "Neptech",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Võ Công Hai - Giám đốc",
                    "LinhVucHoatDong": "Cơ khí chính xác và tự động hóa",
                    "TenDuAnDauTu": "Đầu tư xây dựng & trang thiết bị cho Trung tâm Thiết kế Chế tạo Thiết bị mới",
                    "MucTieuQuyMoDuAn": [
                        "- Nghiên cứu kỹ thuật để thiết kế chế tạo các thiết bị có tính năng tương đương thiết bị ngoại nhập với chi phí thấp.",
                        "- Phối hợp các Viện, các Trung tâm nghiên cứu chuyên ngành, các cơ sở gia công tại TP để thiết kế, chế tạo sản phẩm, thiết bị có nhu cầu cao trên thị trường và sản xuất thử nghiệm một số sản phẩm, thiết bị từ kết quả các đề tài nghiên cứu triển khai và từ các nguồn sàng tạo khác.",
                        "- Chuyển giao thiết kế và CN chế tạo sản phẩm, thiết bị mới cho các đơn vị trong nước SX với quy mô lớn để cung cấp cho nhu cầu thị trường trong & ngoài nước​."
                    ],
                    "DiaChiTrongKhu": "Lô I-3b-3, Đường N6",
                    "DienThoai": "37367127",
                    "Fax": "37367260",
                    "Website": "http://www.neptech.com.vn/‎",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 538.8125, 653.25 ],
                        [ 536.1875, 651 ],
                        [ 535.8125, 648.625 ],
                        [ 535.4375, 646.625 ],
                        [ 536.0625, 645.25 ],
                        [ 558.3125, 648.875 ],
                        [ 552.8125, 655.125 ],
                        [ 550.1875, 654.625 ],
                        [ 547.6875, 653.125 ],
                        [ 543.5625, 652.625 ],
                        [ 538.8125, 653.25 ]
                    ]
                ]
            }
        },
        
        {
            "type": "Feature",
            "id": "I-3b-1.2",
            "properties": {
                "name": "I-3b",
                "gateway": [533.8203125,660.984375],
                "data": {
                    "ID": 45,
                    "TenDoanhNghiep": "Công ty TNHH TLD Hi-Tech",
                    "GoiTat": "Phước Thành TLD",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Bà Phạm Thị Thanh Hằng",
                    "LinhVucHoatDong": "Dịch vụ thương mại",
                    "TenDuAnDauTu": "Nhà xưởng xây dựng sẵn​​​",
                    "MucTieuQuyMoDuAn": [

                    ],
                    "DiaChiTrongKhu": "Lô I-3b-1 (nhà xưởng 1), Đường N6​​",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [[537.53125,665.9375],[542.15625,662.5625],[535.90625,659.8125],[532.15625,662.625],[537.53125,665.9375]]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "I-3b-1.1",
            "properties": {
                "name": "I-3b",
                "gateway": [ 529.796875,664.09375 ],
                "data": {
                    "ID": 32,
                    "TenDoanhNghiep": "Công ty TNHH Kỹ thuật Daikou Việt Nam",
                    "GoiTat": "Daikou Tech",
                    "QuocGia": "Nhật Bản",
                    "DaiDienPhapLuat": "Ông Yoshio Matsumura - Tổng Giám đốc",
                    "LinhVucHoatDong": "Cơ khí chính xác và tự động hóa",
                    "TenDuAnDauTu": "Trung tâm Nghiên cứu Thiết kế Chế tạo Lắp ráp Cơ khí chính xác và Tự động hóa",
                    "MucTieuQuyMoDuAn": [
                        "a) Mục tiêu:",
                        "- Thành lập Trung tâm NC và TK tại KCNC nhằm ứng dụng kết quả hoạt động R&D vào sản xuất các hệ thống máy tự động như máy quấn dây tự động, máy đóng gói tự động, các loại robot dùng trong dây chuyền lắp ráp ô tô và thiết bị điện tử và robot gia dụng; phát triển đội ngũ kỹ sư thiết kế.",
                        "- Phối hợp với TT Đào tạo KCNC đào tạo nguồn nhân lực CNC tại VN, đào tạo về kỹ năng thiết kế máy theo tiêu chuẩn Nhật Bản, kỹ thuật lập trình và vận hành các loại robot, ...",
                        "b) Quy mô:",
                        " NC TK và SX trên dưới 18 chủng loại máy móc khác nhau/năm.​"
                    ],
                    "DiaChiTrongKhu": "Lô I-3b-1.1, Đường N6",
                    "DienThoai": "38973656",
                    "Fax": "38973656",
                    "Website": "http://www.daiko-vn.com/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [[523.59375,668.75],[529.21875,672.75],[537.46875,665.9375],[531.96875,662.5625],[523.59375,668.75]]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "K08.2",
            "properties": {
                "name": "K08.2",
                "gateway": [451.671875,673.53125],
                "data": {
                    "ID": 60,
                    "TenDoanhNghiep": "Trung tâm Nghiên cứu và Triển khai Khu Công nghệ cao",
                    "GoiTat": "",
                    "QuocGia": "Việt - Nhật",
                    "DaiDienPhapLuat": "",
                    "LinhVucHoatDong": "Nghiên cứu, triển khai, đào tạo",
                    "TenDuAnDauTu": "Dự án Hợp tác nghiên cứu khoa học giữa Trung tâm Nghiên cứu và Triển khai Khu Công nghệ cao và Trường sau đại học khoa học tổng hợp về con người, Đại học Tsukuba (Nhật Bản)​​",
                    "MucTieuQuyMoDuAn": [
                        "Triển khai các hoạt động nghiên cứu về công nghệ sinh học​"
                    ],
                    "DiaChiTrongKhu": "Lô I3 đường N2 - Trung tâm R&D",
                    "DienThoai": "37360889",
                    "Fax": "37360890",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [[448.421875,670.71875],[455.453125,676.21875],[457.046875,676.25],[466.921875,669.46875],[458.609375,663.59375],[448.421875,670.71875]]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "K08.3",
            "properties": {
                "name": "K08.3",
                "gateway": [451.671875,673.53125],
                "data": {
                    "ID": 65,
                    "TenDoanhNghiep": "Công ty TNHH NC&TK Quang Lượng Tử Việt Mỹ",
                    "GoiTat": "UVP R&D Co., Ltd",
                    "QuocGia": "Việt - Mỹ",
                    "DaiDienPhapLuat": "Bà Nguyễn Thị Kim Trâm - Giám đốc",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Nhà máy sản xuất và ứng dụng công nghệ LED​​",
                    "MucTieuQuyMoDuAn": [
                        "- Giai đoạn I (2012-2014): ​SX thử tại KCNC với quy mô là 200.000 sản phẩm mẫu.",
                        "- Giai đoạn II (2014 trở đi): Xây dựng nhà máy SX & ứng dụng CN LED trên quy mô SX là 5 triệu sản phẩm/tháng.​​"
                    ],
                    "DiaChiTrongKhu": "Lô I3 đường N2 - Trung tâm R&D",
                    "DienThoai": "37361942",
                    "Fax": "37360714",
                    "Website": "http://uvt-diodes.com",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [[448.421875,670.71875],[455.453125,676.21875],[457.046875,676.25],[466.921875,669.46875],[458.609375,663.59375],[448.421875,670.71875]]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "K09",
            "properties": {
                "name": "K09",
                "gateway": [473.0625,665.4375],
                "data": {
                    "ID": 47,
                    "TenDoanhNghiep": "Công ty TNHH MTV Seen Miền Nam",
                    "GoiTat": "SEEN Southern, Ltd",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Trần Quách Bá Vinh - Giám đốc",
                    "LinhVucHoatDong": "Dịch vụ CNC",
                    "TenDuAnDauTu": "Trung tâm Nghiên cứu, Phát triển Công nghệ Môi trường và Tự động hóa​",
                    "MucTieuQuyMoDuAn": [
                        "- Xây dựng Trung tâm Nghiên cứu Phát triển.",
                        "- Xây dựng các PTN kỹ thuật cần thiết cho công tác NCKH ứng dụng của 2 ngành CN xử lý nước thải, rác thải và CN tự động hóa quá trình công nghiệp.",
                        "- Xây dựng nhà máy SX thiết bị thực nghiệm từ kết quả nghiên cứu của công ty với công suất dự kiến đạt 10.000 sản phẩm/năm.",
                        "- Đảm bảo năng lực xử lý ô nhiễm môi trường đối với các loại nước thải (công nghiệp, nước thải bãi rác, nước thải sinh hoạt ...) với công suất 50.000 m3/năm."
                    ],
                    "DiaChiTrongKhu": "Lô I3-8b, đường N2",
                    "DienThoai": "37306282",
                    "Fax": "37306243",
                    "Website": "http://seen.com.vn",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[472.28125,654.4375],[459.15625,663.5],[467.09375,669.4375],[476.53125,663],[475.59375,662.0625],[474.65625,661.25],[473.78125,660.25],[473.28125,658.875],[472.53125,657.3125],[472.28125,654.4375]]]
            }
        },
        {
            "type": "Feature",
            "id": "VIETCO",
            "properties": {
                "name": "VIETCO",
                "gateway": [495.109375,614.46875],
                "data": {
                    "ID": 22,
                    "TenDoanhNghiep": "Công ty TNHH Công nghệ sinh học Dược Na No Gen",
                    "GoiTat": "Nanogen",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Hồ Nhân - Chủ tịch - Tổng Giám đốc",
                    "LinhVucHoatDong": "Công nghệ sinh học",
                    "TenDuAnDauTu": "-  Dự án sản xuất dược phẩm Nanogen -  Trung tâm Nghiên cứu, sản xuất thử nghiệm và chuyển giao công nghệ dược phẩm công nghệ sinh học giai đoạn 2",
                    "MucTieuQuyMoDuAn": [
                        "a) Mục tiêu của dự án:",
                        "- Sản xuất nguyên liệu và sản xuất thuốc từ dược liệu (như thuốc trị ung thư, thuốc kháng sinh, kháng virut  thế hệ mới và các loại thuốc...) bằng công nghệ sinh học, công nghệ gene.",
                        "- Trung tâm nghiên cứu, sản xuất thử nghiệm và chuyển giao công nghệ dược phẩm công nghệ sinh học giai đoạn 2.",
                        "b) Quy mô của dự án: 24.000.000 (Hai mươi bốn triệu sản phẩm/ năm)"
                    ],
                    "DiaChiTrongKhu": "Lô I-5c",
                    "DienThoai": "37309940",
                    "Fax": "",
                    "Website": "http://www.nanogenpharma.com",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 474.875, 628.9375 ],
                        [ 500.125, 633.6875 ],
                        [ 507.375, 621.3125 ],
                        [ 512.875, 608.0625 ],
                        [ 506.625, 606.6875 ],
                        [ 474.875, 628.9375 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "CTBIO",
            "properties": {
                "name": "HUDEN",
                "gateway": [510.1875,621.5625],
                "data": {
                    "ID": 5,
                    "TenDoanhNghiep": "Công ty Cổ phần CTCBIO Việt Nam",
                    "GoiTat": "CTCBIO",
                    "QuocGia": "Việt - Hàn",
                    "DaiDienPhapLuat": "Jung In Seo - Chủ tịch HĐTV",
                    "LinhVucHoatDong": "Công nghệ sinh học",
                    "TenDuAnDauTu": "Nhà máy CTCBIO tại TPHCM​",
                    "MucTieuQuyMoDuAn": [
                        "Sản xuất chất bổ sung thức ăn gia súc"
                    ],
                    "DiaChiTrongKhu": "Lô I5-3a, I5-3b",
                    "DienThoai": "37361333",
                    "Fax": "",
                    "Website": "http://ctcbio.com.vn/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 500.375, 633.6875 ],
                        [ 506.625, 621.4375 ],
                        [ 508.875, 621.4375 ],
                        [ 518.125, 623.4375 ],
                        [ 512, 635.0625 ],
                        [ 509.75, 634.9375 ],
                        [ 500.375, 633.6875 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "PLAM KHOA.1",
            "properties": {
                "name": "PLAM KHOA",
                "gateway": [518.015625,605.296875],
                "data": {
                    "ID": 11,
                    "TenDoanhNghiep": "Chi nhánh CNSH Công ty TNHH DV&TM Nam Khoa",
                    "GoiTat": "DV&TM Nam Khoa",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Bà Trương Thị Diệu Hồng - Giám đốc",
                    "LinhVucHoatDong": "Công nghệ sinh học",
                    "TenDuAnDauTu": "Chi nhánh công nghệ sinh học Công ty TNHH DV&TM Nam khoa​",
                    "MucTieuQuyMoDuAn": [
                        "- Mục tiêu: Sản xuất các chất trợ sinh và các chất chẩn đoàn bằng kỹ thuật sinh học phân tử​.",
                        "- Quy mô: 5.000.000 (năm triệu) sản phẩm/năm."
                    ],
                    "DiaChiTrongKhu": "Lô I5-2",
                    "DienThoai": "37715818",
                    "Fax": "37752250",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [[517.34375,607.5625],[527.28125,610.4375],[529.78125,606],[519.09375,603.125],[517.34375,607.5625]]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "PLAM KHOA.2",
            "properties": {
                "name": "PLAM KHOA",
                "gateway": [ 515.296875,612.03125],
                "data": {
                    "ID": 19,
                    "TenDoanhNghiep": "Công ty TNHH CNSH Bioland Nam Khoa",
                    "GoiTat": "Bioland Nam Khoa",
                    "QuocGia": "Hàn Quốc",
                    "DaiDienPhapLuat": "Bà Trương Thị Diệu Hồng - Giám đốc",
                    "LinhVucHoatDong": "Công nghệ sinh học",
                    "TenDuAnDauTu": "Công ty TNHH Công Nghệ Sinh Học Bioland - Nam Khoa",
                    "MucTieuQuyMoDuAn": [
                        "Sản xuất các chất chẩn đoán bằng kỹ thuật sinh học phân tử và công nghệ nano"
                    ],
                    "DiaChiTrongKhu": "Lô I5-2a",
                    "DienThoai": "37715818",
                    "Fax": "37750583",
                    "Website": "http://www.nk-biotek.com.vn",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
[[527.09375,610.5625],[522.09375,620.5],[514.96875,618.9375],[513.21875,617.375],[517.09375,607.75],[527.09375,610.5625]]

                ]
            }
        },
        {
            "type": "Feature",
            "id": "K13",
            "properties": {
                "name": "K13",
                "gateway": [520.734375,598.5],
                "data": {
                    "ID": 72,
                    "TenDoanhNghiep": "Công ty TNHH Thế giới GEN",
                    "GoiTat": "Genworld Co., Ltd",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Nguyễn Văn Lễ - Chủ tịch HĐTV",
                    "LinhVucHoatDong": "Công nghệ sinh học",
                    "TenDuAnDauTu": "Công ty TNHH Thế giới GEN​",
                    "MucTieuQuyMoDuAn": [
                        "- Thành lập trung tâm công nghệ sinh học tiên tiến, tế bào và tế bào gốc tại Khu Công nghệ cao.",
                        "- Sản xuất các bộ kit, môi trường phục vụ cho phân lập, nuôi cấy, tăng sinh và biệt hóa tế bào gốc ứng dụng trong chẩn đoán, điều trị và thay thế mô và cơ quan.",
                        "- Sản xuất tế bào gốc phục vụ cho cấy ghép tự thân và đồng ghép.",
                        "- Sản xuất các chế phẩm sinh học từ công nghệ tế bào gốc phục vụ cho tăng cường sức khỏe (dạng thực phẩm chức năng) hay làm đẹp (mỹ phẩm).",
                        "- Sản xuất kit, hóa chất bằng công nghệ gen phục vụ cho chẩn đoán, giám định và điều trị."
                    ],
                    "DiaChiTrongKhu": "Lô I5-1, Đường N7",
                    "DienThoai": "37361979",
                    "Fax": "37361977",
                    "Website": "http://geneworld.vn/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 529.875, 605.8125 ],
                        [ 522.875, 604.3125 ],
                        [ 519.25, 602.9375 ],
                        [ 522.25, 596.0625 ],
                        [ 530.5, 589.9375 ],
                        [ 535, 595.5625 ],
                        [ 535.875, 598.0625 ],
                        [ 529.875, 605.8125 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "I4",
            "properties": {
                "name": "I4 - ALLIED",
                "gateway": [574.3125,647.25],
                "data": {
                    "ID": 71,
                    "TenDoanhNghiep": "Công ty TNHH Sài Gòn Allied Tecnologies",
                    "GoiTat": "ATSC",
                    "QuocGia": "Singapore",
                    "DaiDienPhapLuat": "Ông Hsu Ching Yuh - Chủ tịch HĐTV",
                    "LinhVucHoatDong": "Cơ khí chính xác và tự động hóa",
                    "TenDuAnDauTu": "Công ty TNHH Sài Gòn Allied Tecnologies​",
                    "MucTieuQuyMoDuAn": [
                        "- Thiết kế, chế tạo công cụ bào, gọt và bàn ren kỹ thuật cao. SX các bộ phận dập hình nổi chính xác cao. Lắp ráp các bộ phận linh kiện kim loại cho máy in, máy vi tính, máy mạng, thiết bị viễn thông, đầu đọc KT số, tất cả các thiết bị cơ khí, điện, điện tử gia dụng.",
                        "- SX linh kiện, chi tiết bằng nhựa chính xác cao. SX chi tiết bộ phận nhựa màu bằng khuôn đúc kỹ thuật cao. Thiết kế & SX khuôn đúc chính xác. Lắp ráp những bộ phận cơ khí chính xác cao của máy in, máy vi tính, máy mạng, thiết bị viễn thông, đầu máy DVD, tất cả các thiết bị cơ khí, điện, điện tử gia dụng, thiết bị y tế, trang thiết bị văn phòng.",
                        "- SX & lắp ráp những dòng sản phẩm về máy vi tính & những sản phẩm về lĩnh vực in ấn và hình ảnh, thiết bị đo đạc, hệ thống mạng ​& viễn thông, máy tính, thiết bị lưu trữ dữ liệu xách tay & dụng cụ y tế..."
                    ],
                    "DiaChiTrongKhu": "Lô I4, F03 & F04",
                    "DienThoai": "37335663",
                    "Fax": "37335668",
                    "Website": "http://niengiamtrangvang.com/ad.asp?URL=http://www.allied-tech.com.sg",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 533, 639.875 ],
                        [ 597.25, 651.375 ],
                        [ 612.75, 609.375 ],
                        [ 612, 604.625 ],
                        [ 609.75, 601.875 ],
                        [ 578.25, 595.875 ],
                        [ 553.25, 601.875 ],
                        [ 547.75, 607.625 ],
                        [ 542, 614.125 ],
                        [ 535.75, 630.125 ],
                        [ 533, 639.875 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "tld",
            "properties": {
                "name": "tld",
                "gateway": [302.15625,729.3125],
                "data": {
                    "ID": 44,
                    "TenDoanhNghiep": "Công ty TNHH Thương mại Đầu tư TLD",
                    "GoiTat": "",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Phan Anh Hưng - Giám đốc",
                    "LinhVucHoatDong": "Dịch vụ thương mại",
                    "TenDuAnDauTu": "​​​",
                    "MucTieuQuyMoDuAn": [
                        "a) Mục tiêu dự án:",
                        "Xây dựng khu Nhà trẻ, Siêu thị tiện lợi và Nhà hàng nhằm tạo môi trường dịch vụ đa dạng, phong phú và có tính thích ứng cao, từ đó, gia tăng năng lực cung cấp dịch vụ để đáp ứng nhu cầu ngày càng cao của mọi cá nhân, tổ chức hoạt động trong Khu công nghệ cao Thành phố Hồ Chí Minh",
                        "b) Quy mô dự án:",
                        "Sử dụng diện tích đất dự kiến là 8.086,84 m2, đáp ứng nhu cầu phục vụ dự kiến trên 300 trẻ và 1.000 lượt khách hàng đến Siêu thị và Nhà hàng mỗi ngày"
                    ],
                    "DiaChiTrongKhu": "Lô T2-1.1b, Đường D1​​",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 282.6875, 726.625 ],
                        [ 284.9375, 732.5 ],
                        [ 290.4375, 731.625 ],
                        [ 295.3125, 730.625 ],
                        [ 299.8125, 730 ],
                        [ 302.3125, 729.25 ],
                        [ 305.3125, 728.875 ],
                        [ 308.0625, 727.875 ],
                        [ 311.5625, 726.875 ],
                        [ 315.6875, 725.25 ],
                        [ 318.0625, 724.125 ],
                        [ 320.3125, 723.125 ],
                        [ 308.6875, 711.125 ],
                        [ 282.6875, 726.625 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "hdbank",
            "properties": {
                "name": "hd",
                "gateway": [329.28125,717.9375],
                "data": {
                    "ID": 46,
                    "TenDoanhNghiep": "Ngân hàng TMCP Phát triển Thành phố Hồ Chí Minh",
                    "GoiTat": "HD Bank",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Nguyễn Hữu Đặng",
                    "LinhVucHoatDong": "Dịch vụ thương mại",
                    "TenDuAnDauTu": "Xây dựng hạ tầng công nghệ và cung cấp dịch vụ tài chính tại Khu Công nghệ cao Thành phố Hồ Chí Minh​​​",
                    "MucTieuQuyMoDuAn": [
                        "Cung cấp dịch vụ tài chính hỗ trợ doanh nghiệp tại Khu Công nghệ cao và cung cấp sản phẩm tài chính thông qua Quỹ hỗ trợ phát triển công nghệ cao."
                    ],
                    "DiaChiTrongKhu": "Lô T2-1.5, Đường D1",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "https://www.hdbank.com.vn/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 320.1875, 723 ],
                        [ 324.0625, 721.125 ],
                        [ 327.0625, 719.5 ],
                        [ 330.3125, 717.375 ],
                        [ 333.1875, 715.125 ],
                        [ 335.5625, 713.625 ],
                        [ 337.9375, 712.125 ],
                        [ 340.4375, 710.625 ],
                        [ 343.6875, 708.25 ],
                        [ 346.1875, 706.625 ],
                        [ 348.4375, 704.75 ],
                        [ 335.6875, 694.625 ],
                        [ 308.8125, 711.125 ],
                        [ 320.1875, 723 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "C1-2",
            "properties": {
                "name": "C1-2 KHU-PHUC-HOP",
                "gateway": [191.1875,758.625],
                "data": {
                    "ID": 16,
                    "TenDoanhNghiep": "Công ty TNHH Ascendas Saigon Bund",
                    "GoiTat": "ASCENDAS SAIGON",
                    "QuocGia": "Singapore - Vương quốc Anh",
                    "DaiDienPhapLuat": "Ông Han Ann Foong - Tổng Giám đốc",
                    "LinhVucHoatDong": "Dịch vụ thương mại",
                    "TenDuAnDauTu": "Khu phức hợp Onehub Saigon​​",
                    "MucTieuQuyMoDuAn": [
                        "- Phát triển dự án khu phức hợp bao gồm các tòa nhà trong khu phức hợp, các cơ sở bán lẻ, tòa nhà WOHO (Work Office Home Office) và cơ sở giáo dục.​",
                        "- Điều hành và quản lý khu phức hợp bao gồm (nhưng không giới hạn) các hoạt động sau:",
                        "+ cho thuê hoặc bán mặt bằng trong các tòa nhà;",
                        "+ cho thuê hoặc bán các công trình hoặc các đơn vị riêng lẻ của các công trình trong khu phức hợp;",
                        "+ duy trì chất lượng của các cấu trúc xây dựng và các khu vực công cộng trong phạm vi khu phức hợp;",
                        "+ duy trì an ninh trong khu phức hợp;",
                        "+ thiết lập và thu tiền thuê mặt bằng, các khoản phí dịch vụ hợp với các qui định hiện hành của Việt Nam.",
                        "-  Cung cấp các dịch vụ liên quan trong khu phức hợp bao gồm (nhưng không giới hạn) các hoạt động sau:",
                        "+ dịch vụ quản lý bãi giữ xe;",
                        "+ dịch vụ bãi giữ xe;",
                        "+ dịch vụ dịch vụ vệ sinh;",
                        "+ dịch vụ về các tiện ích như điện và nước, vv.vv."
                    ],
                    "DiaChiTrongKhu": "Lô C1-2, Đường D1",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 200.5, 821.625 ],
                        [ 222.25, 795.625 ],
                        [ 232, 789.375 ],
                        [ 238.25, 780.875 ],
                        [ 238.25, 774.125 ],
                        [ 237.5, 768.625 ],
                        [ 224, 769.875 ],
                        [ 217.5, 753.375 ],
                        [ 178.75, 760.875 ],
                        [ 168.5, 765.125 ],
                        [ 147.25, 787.875 ],
                        [ 150.25, 794.125 ],
                        [ 154.75, 796.125 ],
                        [ 157.25, 803.875 ],
                        [ 200.5, 821.625 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "CMC",
            "properties": {
                "name": "CMC",
                "gateway": [222.40625,752.5625],
                "data": {
                    "ID": 1,
                    "TenDoanhNghiep": "Công ty Cổ phần Tập đoàn Công nghệ CMC",
                    "GoiTat": "CMC",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Nguyễn Trung Chính - Tổng Giám đốc",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Xây dựng mạng Hạ tầng Viễn thông – Internet Khu Công nghệ cao TPHCM - Giai đoạn 1​",
                    "MucTieuQuyMoDuAn": [
                        "- Đầu tư xây dựng hoàn chỉnh hệ thống mạng hạ tầng viễn thông - Internet tiên tiến, đạt các chuẩn cao nhất của quốc tế theo thiết kế cơ sở đã được phê duyệt của BQLKCNC, nhằm cung cấp các dịch vụ viễn thông - Internet từ cơ bản đến nâng cao cho các khách hàng là các nhà đầu tư, doanh nghiệp, cá nhân hoạt động trong nội bộ KCNC​.",
                        "- Đầu tư xây dựng cơ sở dữ liệu (Data Center) nhằm cung cấp dịch vụ Datacenter cho các khách hàng trong KCNC.​​"
                    ],
                    "DiaChiTrongKhu": "Lô C1-1, đường D1",
                    "DienThoai": "22264777",
                    "Fax": "",
                    "Website": "http://www.cmc.com.vn/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 236.6875, 767.53125 ],
                        [ 223.75, 769.84375 ],
                        [ 218.0625, 753.40625 ],
                        [ 227.1875, 751.46875 ],
                        [ 230.3125, 752.46875 ],
                        [ 236.6875, 767.53125 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "T2-1-2",
            "properties": {
                "name": "K15",
                "gateway": [562.828125,660.75],
                "data": {
                    "ID": 20,
                    "TenDoanhNghiep": "Công ty TNHH công nghệ Fawookidi",
                    "GoiTat": "Fawookidi",
                    "QuocGia": "Việt - Hàn",
                    "DaiDienPhapLuat": "Bà Lê Thu Trang - Tổng Giám đốc",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Trung tâm nghiên cứu và chế tạo công nghệ LED Fawookidi",
                    "MucTieuQuyMoDuAn": [
                        "Ứng dụng công nghệ tiên tiến của Hàn Quốc để nghiên cứu, sản xuất và kinh doanh đèn LED hiệu suất cao, thân thiện với môi trường. Sản phẩm được ứng dụng trong chiếu sáng hộ gia đình và khối văn phòng, khu mua sắm, siêu thị; đèn đường và đèn bảo an trong chiếu sáng công cộng, đèn pha cho các nhà máy xí nghiệp, đèn dẫn dụ cá phục vụ ngành ngư nghiệp, đèn chống cháy nổ, đèn đường hầm, v.v…thay thế hàng nhập khẩu, giảm giá thành sản phẩm"
                    ],
                    "DiaChiTrongKhu": "Lô I-3B-4-A, Đường N6, Khu Công Nghệ Cao",
                    "DienThoai": "37252269",
                    "Fax": "37360666",
                    "Website": "http://www.fawookidi.com.vn",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [[552.546875,655.3125],[566.796875,662.625],[576.390625,651.9375],[558.453125,648.84375],[552.546875,655.3125]]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "PLAMSOON.1",
            "properties": {
                "name": "PLAMSOON.1",
                "gateway": [406.46875,665],
                "data": {
                    "ID": 3,
                    "TenDoanhNghiep": "Công ty Cổ phần Bán dẫn Việt Nam",
                    "GoiTat": "VSMC",
                    "QuocGia": "Mỹ",
                    "DaiDienPhapLuat": "Ông Vo Hai Huu - Tổng Giám đốc",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Công ty CP Bán dẫn Việt Nam (VSMC)",
                    "MucTieuQuyMoDuAn": [
                        "VSMC là một công ty \"không nhà máy\", chuyên thiết kế và sản xuất các sản phẩm \"Quản lý Năng lượng bằng giải pháp Digital\", các sản phẩm bộ nhớ áp dụng cho các sản phẩm đặc thù khác, cùng với các sản phẩm về sở hữu trí tuệ, các sản phẩm IC Analog, IC tín hiệu tổng hợp cho các thị trường dân dụng và viễn thông.​"
                    ],
                    "DiaChiTrongKhu": "Lô T2-4, đường D1",
                    "DienThoai": "54001915",
                    "Fax": "54001915",
                    "Website": "http://www.vsmc.com.vn/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 413.375, 660.1875 ],
                        [ 401.125, 668.8125 ],
                        [ 390.75, 661.1875 ],
                        [ 403.875, 653.0625 ],
                        [ 413.375, 660.1875 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "PLAMSOON.2",
            "properties": {
                "name": "PLAMSOON.2",
                "gateway": [406.46875,665],
                "data": {
                    "ID": 7,
                    "TenDoanhNghiep": "Công ty cồ phần hệ thống công nghệ Ánh Lam",
                    "GoiTat": "Indigo JSC",
                    "QuocGia": "Việt - Malaysia",
                    "DaiDienPhapLuat": "Ông Phạm Phú Khánh - Giám đốc",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Công ty CP Hệ thống công nghệ Ánh Lam",
                    "MucTieuQuyMoDuAn": [
                        "- Lập trình máy vi tính, dịch vụ tư vấn và các hoạt động khác liên quan đến máy vi tính",
                        "- Dịch vụ xây dựng cơ sở dữ liệu, khai thác cơ sở dữ liệu phục vụ nghiên cứu và phát triển CNC",
                        "- Nghiên cứu phát triển - tư vấn lựa chọn trển khai tích hợp - phát triển"
                    ],
                    "DiaChiTrongKhu": "Lô T2-4 (Tầng 3)",
                    "DienThoai": "38389868",
                    "Fax": "",
                    "Website": "http://www.indigo-jsc.com/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 413.375, 660.1875 ],
                        [ 401.125, 668.8125 ],
                        [ 390.75, 661.1875 ],
                        [ 403.875, 653.0625 ],
                        [ 413.375, 660.1875 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "PLAMSOON.3",
            "properties": {
                "name": "PLAMSOON.3",
                "gateway": [406.46875,665],
                "data": {
                    "ID": 17,
                    "TenDoanhNghiep": "Công ty TNHH Chíp sáng và Ashmanov",
                    "GoiTat": "Chíp sáng & Ashmanov",
                    "QuocGia": "Việt - Nga",
                    "DaiDienPhapLuat": "Ông Lâm Chi Thương - Tổng Giám đốc",
                    "LinhVucHoatDong": "Dịch vụ CNC",
                    "TenDuAnDauTu": "Thành lập Liên doanh Chíp Sáng - Ashmanov​​​",
                    "MucTieuQuyMoDuAn": [
                        "- Xây dựng nền tảng công nghệ phân tích ngữ nghĩa và triển khai các ứng dụng internet thông qua nghiên cứu và phát triển các công nghệ trí tuệ nhân tạo, xử lý ngôn ngữ tự nhiên; thiết kế và phát triển phần mềm, cung cấp các sản phẩm, dịch vụ và ứng dụng công nghệ thông tin và viễn thông (bộ lọc web, hệ thống tổng hợp và phân tích thông tin, dịch vụ tiếp thị theo ngữ cảnh, dịch vụ  tối ưu hoá tìm kiếm, người đối thoại ảo,...)",
                        "- Triển khai kinh doanh các sản phẩm, giải pháp công nghệ thông tin và viễn thông trên phạm vị thị trường Đông Nam Á với đối tượng khách hàng ban đầu là các cơ quan chính phủ, các doanh nghiệp viễn thông, doanh nghiệp tài chính, bán lẻ."
                    ],
                    "DiaChiTrongKhu": "Lầu 6, tòa nhà BCIS, lô T2-4, đường D1, KCNC",
                    "DienThoai": "39339955",
                    "Fax": "39333486",
                    "Website": "http://www.csa.vn/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 413.375, 660.1875 ],
                        [ 401.125, 668.8125 ],
                        [ 390.75, 661.1875 ],
                        [ 403.875, 653.0625 ],
                        [ 413.375, 660.1875 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "PLAMSOON.4",
            "properties": {
                "name": "PLAMSOON.4",
                "gateway": [406.46875,665],
                "data": {
                    "ID": 36,
                    "TenDoanhNghiep": "Công ty TNHH MTV Dịch vụ Quy trình Phần mềm FPT",
                    "GoiTat": "FPS",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Hoàng Nam Tiến - Chủ tịch",
                    "LinhVucHoatDong": "Dịch vụ CNC",
                    "TenDuAnDauTu": "Công ty TNHH MTV Dịch vụ Quy trình Phần mềm FPT​",
                    "MucTieuQuyMoDuAn": [
                        "- NC, phát triển, sx và kinh doanh các sản phẩm phần mềm ​ứng dụng trong CNTT như sau:",
                        "+ Nền tảng dịch vụ quy trình cho khách hàng dưới dạng \"Phần mềm như 1 dịch vụ\" (Software as a Service) trên nền tảng điện toán đám mây và ảo hóa, dựa trên TT dữ liệu được xây dựng bỡi FPS.",
                        "+ Phần mềm đảm bảo an ninh, an toàn mạng và bí mật thông tin ở mức cao, tích hợp xử lý, phân tích dữ liệu và hỗ trợ trong việc đưa ra quyết định.",
                        "+ Phần mềm nhận dạng, xử lý ảnh và tiếng nói.",
                        "- Khách hàng mục tiêu: cung cấp cho các công ty đối tác hoạt động đa lĩnh vực (CNTT, bảo hiểm, dầu khí, thương mại, ...) trên TG, đặc biệt là ĐNÁ."
                    ],
                    "DiaChiTrongKhu": "Tầng 5, tòa nhà Sacom Chíp sáng, Lô T2-4, đường D1",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 413.375, 660.1875 ],
                        [ 401.125, 668.8125 ],
                        [ 390.75, 661.1875 ],
                        [ 403.875, 653.0625 ],
                        [ 413.375, 660.1875 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "PLAMSOON.5",
            "properties": {
                "name": "PLAMSOON.5",
                "gateway": [406.46875,665],
                "data": {
                    "ID": 40,
                    "TenDoanhNghiep": "Công ty TNHH MTV Micro Precision Calibration Việt Nam",
                    "GoiTat": "MPC Vietnam Ltd., Co.",
                    "QuocGia": "Thái Lan",
                    "DaiDienPhapLuat": "Ông Jarrod Owen Trammell - Giám đốc",
                    "LinhVucHoatDong": "Nghiên cứu & Triển khai",
                    "TenDuAnDauTu": "Micro Precision Calibration Việt Nam​",
                    "MucTieuQuyMoDuAn": [
                        "a) Mục tiêu:",
                        "Thiết lập phòng thí nghiệm (phòng lab) thực hiện dịch vụ hiệu chuẩn và kiểm tra thiết bị, dịch vụ sửa chữa thiết bị.",
                        "b) Quy mô:",
                        "- Giai đoạn đầu (một năm sau khi đi vào hoạt động): kiểm tra được 3.500 (ba ngàn năm trăm) thiết bị/ năm, đạt giá trị doanh thu 350.000 (ba trăm năm mươi ngàn) Đôla Mỹ/ năm.",
                        "- Giai đoạn ổn định (từ ba đến năm năm sau khi đi vào hoạt động): kiểm tra được 5.000 (năm ngàn) thiết bị/ năm.​"
                    ],
                    "DiaChiTrongKhu": "Phòng 201, Tầng 2, Tòa nhà Sacom Chip sáng, Lô T2-4, Đường D1",
                    "DienThoai": "54482008",
                    "Fax": "54482009",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 413.375, 660.1875 ],
                        [ 401.125, 668.8125 ],
                        [ 390.75, 661.1875 ],
                        [ 403.875, 653.0625 ],
                        [ 413.375, 660.1875 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "PLAMSOON.6",
            "properties": {
                "name": "PLAMSOON.6",
                "gateway": [406.46875,665],
                "data": {
                    "ID": 41,
                    "TenDoanhNghiep": "Công ty TNHH MTV Microchip Technology (Việt Nam)",
                    "GoiTat": "MTVN",
                    "QuocGia": "Ireland",
                    "DaiDienPhapLuat": "Ông James Eric Bjornholt - Chủ tịch",
                    "LinhVucHoatDong": "Nghiên cứu, triển khai, đào tạo",
                    "TenDuAnDauTu": "Trung Tâm Nghiên Cứu Và Thiết Kế Vi Mạch Bán Dẫn – Microchip Technology (Việt Nam)​​",
                    "MucTieuQuyMoDuAn": [
                        "a) Mục tiêu:",
                        "Thành lập trung tâm kỹ thuật tại Việt Nam trong giai đoạn đầu để đào tạo đội ngũ kỹ sư có trình độ cao có khả năng thực hiện việc nghiên cứu, thiết kế bán dẫn dựa trên những thông số thiết kế định sẵn của Microchip. Hướng đến thiết lập nhà máy sản xuất các thiết bị bán dẫn trong giai đoạn tiếp theo.",
                        "b) Quy mô:",
                        "- Giai đoạn đầu (từ năm 2013 đến năm 2017): các kỹ sư thiết kế mạch tích hợp bán dẫn và bố trí vi mạch của Microchip sẽ thực hiện thiết kế, kiểm tra và sửa chữa các mạch thiết kế dựa trên công nghệ SuperFlash có sẵn.",
                        "- Giai đoạn ổn định (từ năm 2014 trở đi): song song nghiên cứu thiết kế mạch tích hợp bán dẫn, Microchip sẽ đào tạo thêm nhiều kỹ sư trong các lĩnh vực khác để phục vụ cho nhiều lĩnh vực hoạt động khác nhau của Microchip."
                    ],
                    "DiaChiTrongKhu": "Lầu 2, Lô T2-4, Đường D1",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 413.375, 660.1875 ],
                        [ 401.125, 668.8125 ],
                        [ 390.75, 661.1875 ],
                        [ 403.875, 653.0625 ],
                        [ 413.375, 660.1875 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "PLAMSOON.7",
            "properties": {
                "name": "PLAMSOON.7",
                "gateway": [406.46875,665],
                "data": {
                    "ID": 43,
                    "TenDoanhNghiep": "Công ty TNHH Thương mại - Dịch vụ Công nghệ cao",
                    "GoiTat": "",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Bà Nguyễn Thị Mỹ Anh - Tổng Giám đốc",
                    "LinhVucHoatDong": "Dịch vụ thương mại",
                    "TenDuAnDauTu": "Khu Nhà ở và Dịch vụ chuyên gia​​​",
                    "MucTieuQuyMoDuAn": [
                        "Xây dựng, phát triển ​và cho thuê một khu nhà ở trên khu đất có diện tích 61,77 ha tại khu S-H thuộc KCNC TP.HCM và cung cấp các dịch vụ thương mại, dịch vụ công cộng cho các chuyên gia, cán bộ khoa học kỹ thuật, quản lý cao cấp làm việc trong KCNC và các đối tượng được pháp luật VN cho phép"
                    ],
                    "DiaChiTrongKhu": "Lô T2-4, Đường D1​",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 413.375, 660.1875 ],
                        [ 401.125, 668.8125 ],
                        [ 390.75, 661.1875 ],
                        [ 403.875, 653.0625 ],
                        [ 413.375, 660.1875 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "PLAMSOON.8",
            "properties": {
                "name": "PLAMSOON.8",
                "gateway": [406.46875,665],
                "data": {
                    "ID": 50,
                    "TenDoanhNghiep": "Công ty TNHH Rockwell Automation Việt Nam",
                    "GoiTat": "Rockwell Automation Vietnam Co., Ltd",
                    "QuocGia": "Singapore",
                    "DaiDienPhapLuat": "Ông Dương Anh Tuấn - Tổng Giám đốc",
                    "LinhVucHoatDong": "Dịch vụ CNC",
                    "TenDuAnDauTu": "Công ty TNHH Rockwell Automation Việt Nam​",
                    "MucTieuQuyMoDuAn": [
                        "- Cung cấp công nghệ hiện đại về hệ thống, giải pháp và dịch vụ hậu mãi cho các khách hàng của Rockwell Automation.",
                        "- Biến Khu Công nghệ cao TP.HCM thành địa điểm chiến lược để mở rộng hoạt động sản xuất hoặc các dự án đầu tư khác trong vùng Châu Á Thái Bình Dương."
                    ],
                    "DiaChiTrongKhu": "Lầu 5, Toà nhà văn phòng Sacom-Chíp Sáng (BCIS), Lô T2-4, Đường D1",
                    "DienThoai": "62556400",
                    "Fax": "62556411",
                    "Website": "http://www.rockwellautomation.com/sea",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 413.375, 660.1875 ],
                        [ 401.125, 668.8125 ],
                        [ 390.75, 661.1875 ],
                        [ 403.875, 653.0625 ],
                        [ 413.375, 660.1875 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "PLAMSOON.9",
            "properties": {
                "name": "PLAMSOON.9",
                "gateway": [406.46875,665],
                "data": {
                    "ID": 58,
                    "TenDoanhNghiep": "Công ty TNHH Sacom - Chíp sáng",
                    "GoiTat": "SCS",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Bà Phạm Thị Lợi - Tổng Giám đốc",
                    "LinhVucHoatDong": "Dịch vụ thương mại",
                    "TenDuAnDauTu": "Dự án Xây dựng Không gian Internet - Chíp Sáng (Brilliant Chip Internet City)​",
                    "MucTieuQuyMoDuAn": [
                        "Xây dựng cao ốc văn phòng để tự kinh doanh theo chức năng hoặc cho các công ty thuê thuộc lĩnh vực CNC như software, dịch vụ data center, dịch vụ ​Internet viễn thông, dịch vụ giá trị gia tăng trực tuyến, các ứng dụng di động, SX kinh doanh nội dung số v.v... và liên doanh với một số đối tác tiềm năng để SX, TK vi mạch bán dẫn, thực hiện dịch vụ chuyển giao CN"
                    ],
                    "DiaChiTrongKhu": "Lô T2-4, đường D1",
                    "DienThoai": "35222277",
                    "Fax": "35122288",
                    "Website": "http://www.scs.vn/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 413.375, 660.1875 ],
                        [ 401.125, 668.8125 ],
                        [ 390.75, 661.1875 ],
                        [ 403.875, 653.0625 ],
                        [ 413.375, 660.1875 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "KOO",
            "properties": {
                "name": "KOO",
                "gateway": [397.234375,671.1875],
                "data": { "TenDoanhNghiep": "Ban Quản Lý Khu Công Nghệ Cao",
                            "GoiTat":"BQL KCNC",
                            "QuocGia": "Việt Nam",
                            "DaiDienPhapLuat":"",
                            "LinhVucHoatDong":"",
                            "TenDuAnDauTu":"",
                            "DiaChiTrongKhu":"Đường D1, Khu Công Nghệ Cao",
                            "DienThoai":"08.37360293",
                            "Fax":"08.37360292",
                            "Website":"http://www.shtp.hochiminhcity.gov.vn/Pages/default.aspx",
                            "TaiLieuDinhKem":""
                        }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 394.25, 672.8125 ],
                        [ 400.5, 669.0625 ],
                        [ 390.625, 661.6875 ],
                        [ 383.75, 665.4375 ],
                        [ 394.25, 672.8125 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "FPTBuilding",
            "properties": {
                "name": "FPTBuilding",
                "gateway": [384.5625,679.875],
                "data": {
                    "ID": 39,
                    "TenDoanhNghiep": "Công ty TNHH MTV Giải pháp công nghệ FPT",
                    "GoiTat": "FTS Co., Ltd",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Phạm Minh Tuấn - Giám đốc",
                    "LinhVucHoatDong": "Nghiên cứu, triển khai, đào tạo",
                    "TenDuAnDauTu": "Trung tâm Nghiên cứu và Phát triển Giải pháp Công nghệ FPT​",
                    "MucTieuQuyMoDuAn": [
                        "- NC phát triển, nhận chuyển giao CN, ​sx, kinh doanh và cung cấp các sẩn phẩm CNTT. dịch vụ phần mềm, triển khai ứng dụng và các giải pháp CN trọn gói cho thị trường trong & ngoài nước, gồm:",
                        "+ Phần mềm, thiết bị nhận dạng tiếng nói, hình ảnh, cử chỉ, chuyển động dùng trong lĩnh vực an ninh, giao thông, y tế, dịch vụ công.",
                        "+ Phần mềm, thiết bị điều khiển robot.",
                        "+ Phần mềm cho các thiết bị y tế, chẩn đoán bằng hình ảnh. Phần mềm, thiết bị phục vụ y tế thông minh như Telemedicine, e-Healthcare, Bệnh viện KT số, Hồ sơ bệnh án điện tử...",
                        "+ Phần mềm, thiết bị ứng dụng CN RFDI.",
                        "+ Phần mềm, thiết bị ứng dụng CN GPS/GIS trong công tác quản lý đô thị.",
                        "+ Phần mềm, thiết bị phục vụ chính phủ điện tử (e-Gov).",
                        "- NC & phát triển phần mềm, thiêt bị ứng dụng CN thiết kế & sx nhờ máy tính (CAD/CAM).",
                        "- NC & phát triển phần mềm, thiêt bị ứng dụng CN điện toán đám mây.",
                        "- NC & phát triển phần mềm, thiêt bị ứng dụng CN trên thiết bị di động."
                    ],
                    "DiaChiTrongKhu": "Tầng 2 tòa nhà F-town, Lô T2, đường D1",
                    "DienThoai": "37362323",
                    "Fax": "37362333",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[357.0625,698.5],[394.4375,673.375],[384.0625,665.75],[345.1875,689.375],[357.0625,698.5]]]
            }
        },
        {
            "type": "Feature",
            "id": "FPTSoft",
            "properties": {
                "name": "T2-2",
                "gateway": [384.5625,679.875],
                "data": {
                    "ID": 49,
                    "TenDoanhNghiep": "Công ty TNHH Phần mềm FPT Hồ Chí Minh",
                    "GoiTat": "Fsoft HCM",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Nguyễn Đức Quỳnh - Giám đốc",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Trung tâm Nghiên cứu Công nghệ thông tin, Viễn thông ​và Sản xuất phần mềm​",
                    "MucTieuQuyMoDuAn": [
                        "- NC và cung cấp các giải pháp và dịch vụ CNTT, viễn thông và Internet.",
                        "- NC các giải pháp tích hợp hệ thống.",
                        "- NC & SX phần mềm xuất khẩu.​"
                    ],
                    "DiaChiTrongKhu": "Lô T2-2, đường D1",
                    "DienThoai": "37362323",
                    "Fax": "37362333",
                    "Website": "http://www.fpt-software.com/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[357.0625,698.5],[394.4375,673.375],[384.0625,665.75],[345.1875,689.375],[357.0625,698.5]]]
            }
        },
        {
            "type": "Feature",
            "id": "T2-6",
            "properties": {
                "name": "K17",
                "gateway": [440.1875,641.75],
                "data": {
                    "ID": 64,
                    "TenDoanhNghiep": "Trung tâm công nghệ và quản lý môi trường",
                    "GoiTat": "ETM",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Bà Huỳnh Ngọc Phương Mai - Giám đốc",
                    "LinhVucHoatDong": "Nghiên cứu & Triển khai",
                    "TenDuAnDauTu": "Trung tâm công nghệ và quản lý môi trường​",
                    "MucTieuQuyMoDuAn": [
                        "Xây dựng CSHT phục vụ hoạt động NCKH, đào tạo nguồn nhân lực trong lĩnh vực CN môi trường, bao gồm các hạng mục sau:",
                        "- Hệ thống PTN nghiên cứu ứng dụng về CN môi trường, trang thiết bị hiện đại với các mô hình nghiên cứu về CN xử lý chất thải phục vụ cho công tác nghiên cứu và đào tạo về CN.",
                        "- Hệ thống PTN nghiên cứu ứng dụng về CN môi trường.",
                        "- Hệ thống PTN phân tích và đánh giá ô nhiễm môi trường​.",
                        "- Hệ thống phòng họp phục vụ các khóa đào tạo ngắn hạn."
                    ],
                    "DiaChiTrongKhu": "Lô T2-6, Đường D1",
                    "DienThoai": "38981501",
                    "Fax": "38981505",
                    "Website": "http://www.etmcenter.com.vn/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 444.28125, 638.796875 ],
                        [ 437.5625, 643.453125 ],
                        [ 429.25, 637.359375 ],
                        [ 431, 636.640625 ],
                        [ 432.96875, 636.609375 ],
                        [ 444.28125, 638.796875 ]
                    ]
                ]
            }
        },

        {
            "type": "Feature",
            "id": "E2a-III.4",
            "properties": {
                "name": "E2-NCDT",
                "gateway": [634.53125,518.8125],
                "data": {
                    "ID": 27,
                    "TenDoanhNghiep": "Công ty TNHH Eurofins Sắc Ký Hải Đăng",
                    "GoiTat": "Eurofins Sac Ky Hai Dang Co., Ltd",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Bà Phạm Thị Ánh - Tổng Giám đốc",
                    "LinhVucHoatDong": "Công nghệ sinh học",
                    "TenDuAnDauTu": "Công ty TNHH Eurofins Sắc Ký Hải Đăng​",
                    "MucTieuQuyMoDuAn": [
                        "- NC phát triển lĩnh vực hóa phân tích, tổng hợp hóa vi sinh; phục vụ phát triển ngành kiểm soát chất lượng, nông lâm thủy sản, kiểm soát ô nhiễm môi trường.",
                        "- NC ứng dụng thành quả khoa học của ngành sinh học, vật liệu, điều khiển, ngành hóa vào việc phát triển các kỹ thuật phân tích​ tinh vi, giảm thiểu ô nhiễm môi sinh, các kỹ thuật phân tích nhanh hỗ trợ hiệu quả trong việc quản lý vệ sinh an toàn thực phẩm, sử dụng hợp lý và hiệu quả tài nguyên thiên nhiên, tái chế chất thải.​",
                        "- NC, phát triển & chuyển giao các hệ thống phần mềm quản lý chất lượng.",
                        "- Xây dựng các cơ sở NCTK, dịch vụ phân tích và đào tạo chuyên sâu lĩnh vực kiểm tra chất lượng đạt tầm quốc tế, phục vụ các yêu cầu về chất lượng sản phẩm đối với thị trường trong nước và quốc tế, đáp ứng các quy định ngày càng khắt khe, đặc biệt là lĩnh vực vệ sinh an toàn thực phẩm, kiểm soát ô nhiễm môi trường.",
                        "- Đào tạo đội ngũ chuyên gia phục vụ cho các hoạt động NC, phát triển và kiểm ta chất lượng tại PTN các trường ĐH, Viện NC, DN trong & ngoài nước, sử dụng các kỹ thuật phân tích tinh vi, cao cấp."
                    ],
                    "DiaChiTrongKhu": "Lô E2a-III.4, Khu Nghiên cứu - Phát triển - Đào tạo - Ươm tạo KCNC",
                    "DienThoai": "38239643",
                    "Fax": "38239872",
                    "Website": "http://sackyhaidang.com.vn/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 662.875, 549.75 ],
                        [ 669.5625, 547.75 ],
                        [ 672.9375, 546.75 ],
                        [ 675.6875, 545.875 ],
                        [ 678.4375, 545.125 ],
                        [ 680.6875, 544.375 ],
                        [ 683.8125, 542.5 ],
                        [ 685.4375, 541.5 ],
                        [ 687.4375, 539.125 ],
                        [ 692.375, 531.5 ],
                        [ 695.875, 526.5 ],
                        [ 698.625, 524 ],
                        [ 701.375, 521.25 ],
                        [ 704.125, 520 ],
                        [ 702.375, 517.25 ],
                        [ 680.625, 501 ],
                        [ 663.125, 499.75 ],
                        [ 633.375, 520.25 ],
                        [ 662.875, 549.75 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "E2a-II",
            "properties": {
                "name": "E2-NCDT",
                "gateway": [ 608.40625,536.625],
                "data": {
                    "ID": 59,
                    "TenDoanhNghiep": "Trung tâm công nghệ phần mềm TP.HCM",
                    "GoiTat": "",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Trần Ngọc Tuấn - Giám đốc",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Trung tâm đào tạo và nghiên cứu công nghệ Đại học FPT (FURETRA)​",
                    "MucTieuQuyMoDuAn": [
                        "a) Mục tiêu:",
                        "Góp phần đào tạo nguồn nhân lực trình độ cao cho hoạt động NCKH và chuyển giao CN, ươm tạo trong các lĩnh vực CNTT, ​trong tiến trình CNH-HĐH và hội nhập kinh tế thế giới của VN.",
                        "b) Quy mô:",
                        "- Xây dựng Trung tâm đào tạo các chuyên ngành CNTT như kỹ thuật phần mềm, khoa học máy tính, hệ thống thông tin, kỹ thuật điện tử truyền thông, ...; Đào tạo ngắn hạn về CN mới trong lĩnh vực CNTT như robot - trí tuệ nhân tạo, xử lý dữ liệu lớn, điện toán đám mây, hạ tầng mạng và an toàn thông tin, ...; Đào tạo bổ sung phục vụ SX, KD của các DN trong KCNC TP.HCM và Cty phần mềm FPT hiện đang hoạt động trong KCNC.",
                        "- Xây dựng Trung tâm nghiên cứu & triển khai trong lĩnh vực CNTT, tập trung vào các hướng robot - trí tuệ nhân tạo, xử lý dữ liệu lớn, điện toán đám mây, hạ tầng mạng và an toàn thông tin."
                    ],
                    "DiaChiTrongKhu": "Lô E2a-II, Đường D1",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "http://www.fpt.edu.vn/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 628.6875, 567 ],
                        [ 631.5625, 566.125 ],
                        [ 633.8125, 565.375 ],
                        [ 635.5625, 564.5 ],
                        [ 637.9375, 562.625 ],
                        [ 640.9375, 559.875 ],
                        [ 643.0625, 558.25 ],
                        [ 645.6875, 556.125 ],
                        [ 647.8125, 555.125 ],
                        [ 650.4375, 553.75 ],
                        [ 653.0625, 553 ],
                        [ 655.0625, 552.125 ],
                        [ 662.375, 549.75 ],
                        [ 633.625, 520 ],
                        [ 603.125, 539.5 ],
                        [ 628.6875, 567 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "E2a-II.3",
            "properties": {
                "name": "E2-NCDT",
                "gateway": [ 579.0625,556.875],
                "data": {
                    "ID": 21,
                    "TenDoanhNghiep": "Công ty TNHH Công nghệ HPT",
                    "GoiTat": "HPT Technology",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Đinh Hà Duy Linh - Chủ tịch HĐTV",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Trung tâm Nghiên cứu và Ứng dụng Công nghệ Thông tin Truyền thông HPT",
                    "MucTieuQuyMoDuAn": [
                        "- Thành lập Trung tâm phần mềm HPT Software dự kiến cho 100 lập trình viên từ năm 2018, đạt 300 lập trình viên đến năm 2023, sản xuất phần mềm phục vụ thị trường trong & ngoài nước. Trung tâm phần mềm HPT được trang bị các máy tính cá nhân cho lập trình viên dạng terminal, máy chủ ứng dụng cung cấp các ứng dụng lập trình cho coder, máy chủ môi trường, hệ thống lưu trữ, hệ thống Lab, hệ thống bảo mật v.v…",
                        "- Thành lập trung tâm nghiên cứu và chuyển giao Công nghệ bao gồm một chuỗi các phòng thí nghiệm và thực hành trình diễn (Demo) về lĩnh vực CNTT và truyền thông nhằm nghiên cứu và chuyển giao các ứng dụng và giải pháp CNTT tiên tiến nhất dành cho khách hàng là các doanh nghiệp với sự phối hợp cùng các đối tác chiến lược hàng đầu về CNTT mà Công ty HPT đã và đang hợp tác phát triển như Oracle, HP, IBM, CISCO, Microsoft, Dell…",
                        "- Phát triển trung tâm đào tạo CNTT cho các doanh nghiệp, cung cấp dịch vụ tư vấn lựa chọn giải pháp, huấn luyện thực hành cho những doanh nghiệp có nhu cầu ứng dụng để đảm bảo nguồn lực có đủ năng lực triển khai các giải pháp CNTT mới nhất. Ngoài các chương trình đào tạo riêng biệt được thiết kế riêng theo từng yêu cầu cụ thể, HPT sẽ kết hợp với các đối tác quốc tế trong từng lĩnh vực chuyên sâu nhằm nghiên cứu và chuyển giao công nghệ và tri thức cho doanh nghiệp có nhu cầu."
                    ],
                    "DiaChiTrongKhu": "Lô E2a-II.3, Đường D1",
                    "DienThoai": "38458518",
                    "Fax": "38458516",
                    "Website": "http://www.hpt.vn/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 575.5625, 561.25 ],
                        [ 575.3125, 559.25 ],
                        [ 593.8125, 546.625 ],
                        [ 603.1875, 540.125 ],
                        [ 628.625, 567.25 ],
                        [ 625.71875, 567.875 ],
                        [ 619.1875, 569.375 ],
                        [ 611.9375, 571.375 ],
                        [ 602.4375, 573.875 ],
                        [ 598.8125, 574.125 ],
                        [ 596.3125, 574.125 ],
                        [ 591.3125, 572.625 ],
                        [ 587.8125, 570.375 ],
                        [ 575.5625, 561.25 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "Viện Dầu khí Việt Nam",
            "properties": {
                "name": "E2b-1",
                "gateway": [573.09375,550.5],
                "data": {
                    "ID": 70,
                    "TenDoanhNghiep": "Viện Dầu khí Việt Nam",
                    "GoiTat": "",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Phan Ngọc Trung - Viện trưởng",
                    "LinhVucHoatDong": "Nghiên cứu & Triển khai",
                    "TenDuAnDauTu": "Trung tâm phân tích thí nghiệm và Văn phòng Viện Dầu khí Việt Nam tại TP.HCM (VPI's Labs and Offices)​​",
                    "MucTieuQuyMoDuAn": [
                        "Đầu tư phát triển Trung tâm phân tích thí nghiệm Viện Dầu khí VN hiện đại, đồng bộ, ngang tầm quốc tế. Đầu tư phát triển Viện Dầu khí VN khu vực phía Nam thành đơn vị NCKH hoàn chỉnh, đồng bộ trên tất cả chuyên ngành KHCN bao trùm mọi lĩnh vực hoạt động dầu khí: tìm kiếm thăm dò, khai thác, vận chuyển, tàng trữ, phân phối, chế biến, lọc hóa dầu, ​an toàn môi trường, kinh tế và quản lý dầu khí, đào tạo cán bộ, phục vụ quá trình hội nhập và xây dựng Tập đoàn Dầu khí VN"
                    ],
                    "DiaChiTrongKhu": "Trụ sở chính: Lô E-2b-5, Đường D1",
                    "DienThoai": "",
                    "Fax": "38973992",
                    "Website": "http://www.vpi.pvn.vn/vn/Home.aspx",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 565.875, 553 ],
                        [ 569.375, 553.25 ],
                        [ 579.6875, 546.125 ],
                        [ 583.3125, 543.5 ],
                        [ 585.5625, 542 ],
                        [ 564.8125, 522 ],
                        [ 562.8125, 523.625 ],
                        [ 557.3125, 528.75 ],
                        [ 555.8125, 531.5 ],
                        [ 555.0625, 534.875 ],
                        [ 555.4375, 542.625 ],
                        [ 557.3125, 546.25 ],
                        [ 563.5625, 551.75 ],
                        [ 565.875, 553 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "HUTECH",
            "properties": {
                "name": "E2b-1",
                "gateway": [ 618.21875,519.625],
                "data": {
                    "ID": 62,
                    "TenDoanhNghiep": "Viện Công nghệ cao HUTECH - Trường Đại học Kỹ thuật Công nghệ TP.HCM",
                    "GoiTat": "IHT-HUTECH",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Hồ Đắc Lộc - Viện trưởng",
                    "LinhVucHoatDong": "Nghiên cứu, triển khai, đào tạo",
                    "TenDuAnDauTu": "Viện Công nghệ cao HUTECH (IHT-HUTECH)​",
                    "MucTieuQuyMoDuAn": [
                        "Nghiên cứu khoa học - Chuyển giao công nghệ - Đào tạo trình độ cao trong các lĩnh vực CNC (CNTT, CNSH, CN tự động hóa và CN năng lượng mới, năng lượng tái tạo), đồng thời là địa chỉ đầu tư, hợp tác nghiên cứu và chuyển giao CN với các tổ chức và DN trong nước và quốc tế​​"
                    ],
                    "DiaChiTrongKhu": "Lô E2b-1;E2b-2;E2b-3, Đường D1",
                    "DienThoai": "35121507",
                    "Fax": "35120786",
                    "Website": "http://www.hutech.edu.vn/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 585.6875, 542 ],
                        [ 652.125, 495.5 ],
                        [ 652.875, 493.5 ],
                        [ 652.875, 484.5 ],
                        [ 653.0625, 483 ],
                        [ 643.0625, 475.75 ],
                        [ 596.0625, 476.625 ],
                        [ 596.59375, 480.3125 ],
                        [ 596.1875, 485.375 ],
                        [ 594.8125, 489.625 ],
                        [ 592.1875, 494.625 ],
                        [ 579.9375, 507.625 ],
                        [ 564.6875, 521.875 ],
                        [ 585.6875, 542 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "DH-NTT",
            "properties": {
                "name": "E3",
                "gateway": [613.3125,451.75],
                "data": {
                    "ID": 63,
                    "TenDoanhNghiep": "Viện Kỹ thuật Công nghệ cao NTT-Đại học Nguyễn Tất Thành-Chi nhánh Khu Công nghệ cao TP.HCM",
                    "GoiTat": "",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Nguyễn Mạnh Hùng - Giám đốc chi nhánh",
                    "LinhVucHoatDong": "Nghiên cứu, triển khai, đào tạo",
                    "TenDuAnDauTu": "Trung tâm phát triển công nghệ cao Đại Học Nguyễn Tất Thành​​",
                    "MucTieuQuyMoDuAn": [
                        "- Xây dựng viện kỹ thuật cao NTT là một viện nghiên cứu và phát triển có tầm ở khu vực Đông Nam Á. Làm nền tản dịch chuyển Đại học Nguyễn Tất Thành từ Đại học ứng dụng sang Đại học ứng dụng và nghiên cứu, góp phần vào công cuộc đổi mới căn bản và toàn diện nền giáo dục của đất nước, đặc biệt là lĩnh vực giáo dục Đại học.",
                        "- Xây dựng Viện thành một cơ sở khoa học - công nghệ luôn đồng hành với các nhà khoa học trong các hoạt động nghiên cứu ứng dụng và chuyển giao công nghệ. Tập hợp đội ngũ chuyên gia đủ khả năng thực hiện nhiệm vụ nghiên cứu ứng dụng, giải mã công nghệ, hoàn thiện các công nghệ thúc đẩy việc nội địa hóa sản phẩm, tạo lập các doanh nghiệp khoa học-công nghệ.",
                        "- Hỗ trợ nhà khoa học, doanh nghiệp, cá nhân trong việc chế thử, ươm tạo, ​đến quy mô công nghiệp và phát triển sản phẩm.",
                        "- Tư vấn doanh nghiệp tiếp cận, sử dụng công nghệ tiên tiến.",
                        "- Ươm tạo doanh nghiệp trẻ, tạo ra một hệ thống các doanh nghiệp khoa học công nghệ.",
                        "- Đào tạo kiến thức quản lý, đồng hành với các doanh nghiệp khoa học-công nghệ trong giai đọan đầu thành lập.",
                        "- Nâng cao năng lực đào tạo và nghiên cứu khoa học cho trường Đại học Nguyễn Tất Thành.",
                        "- Quy mô: 01 trung tâm chính và 04 phòng thí nghiệm trên tổng diện tích 45.419 m2, gồm:",
                        "(1) Phòng TN CNSH - Y - Dược",
                        "(2) Phòng TN CNTT - Viễn thông",
                        "(3) Phòng TN CN Tự động hóa & Robot",
                        "(4) Phòng TN Năng lượng & Môi trường"
                    ],
                    "DiaChiTrongKhu": "Lô E3-I.1, E3-I.2, E3-I.3, đường D1",
                    "DienThoai": "62619423",
                    "Fax": "",
                    "Website": "http://ntt.edu.vn/ntt_trangchu/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 642.75, 475.125 ],
                        [ 596.5, 476.125 ],
                        [ 592, 470.625 ],
                        [ 581, 463.375 ],
                        [ 557, 455.125 ],
                        [ 530.5, 447.375 ],
                        [ 520.75, 442.125 ],
                        [ 497.75, 426.375 ],
                        [ 499, 422.875 ],
                        [ 521, 406.125 ],
                        [ 537, 400.625 ],
                        [ 555.75, 394.625 ],
                        [ 559.5, 396.125 ],
                        [ 594, 433.625 ],
                        [ 622.75, 459.875 ],
                        [ 642.75, 475.125 ]
                    ]
                ]
            }
        },

        {
            "type": "Feature",
            "id": "I6",
            "properties": {
                "name": "I6",
                "gateway": [
                    868.0625,
                    382.125
                ],
                "data": {
                    "ID": 4,
                    "TenDoanhNghiep": "Công ty Cổ phần Công Viên Sài Gòn Silicon",
                    "GoiTat": "Sài Gòn Silicon",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Nguyễn Minh Hiếu",
                    "LinhVucHoatDong": "Dịch vụ thương mại",
                    "TenDuAnDauTu": "Xây dựng và Phát triển Khu Công viên Sài Gòn Silicon",
                    "MucTieuQuyMoDuAn": [
                        "Quy tụ chuyên gia, nhà khoa học, doanh nghiệp Việt Kiều về đầu tư sản xuất lĩnh vực công nghệ cao và công nghiệp hỗ trợ công nghệ cao",
                        "Thu hút và tiếp cận 11 doanh nghiệp ngành vi mạch bán dẫn của Việt Kiều tại Silicon Valley về đầu tư tại Saigon Silicon City - Khu Công nghệ cao."
                    ],
                    "DiaChiTrongKhu": "Lô I6, Lô I7, Đường D1",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    
                    [
                        [ 854.1849916733491, 484.72169850337826 ],
                        [ 877.5195154525052, 470.5795628796473 ],
                        [ 933.3809511662424, 384.3125355748885 ],
                        [ 932.5, 380.875 ],
                        [ 897.25, 380.875 ],
                        [ 857.5, 386.125 ],
                        [ 832.25, 393.625 ],
                        [ 796, 403.5 ],
                        [ 803, 415.5 ],
                        [ 827, 434.5 ],
                        [ 836, 449.5 ],
                        [ 839, 472.5 ],
                        [ 854.1849916733491, 484.72169850337826 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "I7",
            "properties": {
                "name": "I7",
                "gateway": [
                    867.65625,378.046875
                ],
                "data": {
                    "ID": 4,
                    "TenDoanhNghiep": "Công ty Cổ phần Công Viên Sài Gòn Silicon",
                    "GoiTat": "Sài Gòn Silicon",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Nguyễn Minh Hiếu",
                    "LinhVucHoatDong": "Dịch vụ thương mại",
                    "TenDuAnDauTu": "Xây dựng và Phát triển Khu Công viên Sài Gòn Silicon",
                    "MucTieuQuyMoDuAn": [
                        "Quy tụ chuyên gia, nhà khoa học, doanh nghiệp Việt Kiều về đầu tư sản xuất lĩnh vực công nghệ cao và công nghiệp hỗ trợ công nghệ cao",
                        "Thu hút và tiếp cận 11 doanh nghiệp ngành vi mạch bán dẫn của Việt Kiều tại Silicon Valley về đầu tư tại Saigon Silicon City - Khu Công nghệ cao."
                    ],
                    "DiaChiTrongKhu": "Lô I6, Lô I7, Đường D1",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    
                    [
                        [ 937.25, 373.625 ],
                        [ 940.25, 372.625 ],
                        [ 989.5, 293.875 ],
                        [ 987.75, 291.375 ],
                        [ 975.25, 287.875 ],
                        [ 967, 288.375 ],
                        [ 953, 294.875 ],
                        [ 912, 323.625 ],
                        [ 888, 334.125 ],
                        [ 860.5, 338.625 ],
                        [ 825, 344.625 ],
                        [ 808.5, 346.375 ],
                        [ 791.5, 355.875 ],
                        [ 782.75, 370.375 ],
                        [ 784.5, 385.625 ],
                        [ 787.5, 394.875 ],
                        [ 791.25, 398.625 ],
                        [ 797.5, 398.875 ],
                        [ 816, 390.375 ],
                        [ 860, 377.375 ],
                        [ 904.75, 372.625 ],
                        [ 937.25, 373.625 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "I8-1",
            "properties": {
                "name": "I8-1",
                "gateway": [710.3125,442.125],
                "data": {
                    "ID": 31,
                    "TenDoanhNghiep": "Công ty TNHH Jabil Việt Nam",
                    "GoiTat": "Jabil Vietnam",
                    "QuocGia": "Singapore",
                    "DaiDienPhapLuat": "Ông S Purushothuman K Swaminathan - Tổng Giám đốc",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Công ty TNHH Jabil Việt Nam​​",
                    "MucTieuQuyMoDuAn": [
                        "a) Mục tiêu:",
                        "- Sản suất thiết bị văn phòng và máy tính; sản xuất thiết bị lưu trữ dữ liệu, thiết bị truyền thông, thiết bị y tế và các thiết bị công nghiệp điện tử tiêu dùng; chế tạo mẫu khuôn nhựa chính xác. Cung cấp dịch vụ sửa chữa và bảo trì cho các thiết bị viễn thông, thiết bị mạng và thiết bị lưu trữ, thiết bị trưng bày, thiết bị liên quan đến máy tính và thiết bị điện tử tiêu dùng.",
                        "- Thực hiện kinh doanh hoạt động mua bán hàng hoá và các hoạt động liên quan trực tiếp đến mua bán hàng hoá tại Việt Nam như thực hiện quyền nhập khẩu, quyền phân phối bán buôn (không gắn với lập cơ sở bán buôn), quyền phân phối bán lẻ (không gắn với lập cơ sở bán lẻ) những mặt hàng có mã HS như sau: 2508; 3402; 3403; 3405; 3506; 3810; 3919; 3923; 3926; 4016; 4415; 4802; 4819; 4821; 4823; 4908; 7318; 7320; 7326; 8414; 8443; 8471; 8472; 8473; 8479; 8483; 8501; 8504; 8506; 8515; 8517; 8528; 8531; 8532; 8533; 8534; 8536; 8540; 8541; 8542; 8544; 9031 và quyền xuất khẩu theo luật pháp quy định.",
                        "b) Quy mô: dự kiến tại năm sản xuất ổn định:",
                        "- Máy đọc thẻ từ POS: 1,6 triệu sản phẩm.",
                        "- Bo mạch điện tử PCB các loại: 5 triệu sản phẩm."
                    ],
                    "DiaChiTrongKhu": "Lô I8-1",
                    "DienThoai": "37360547",
                    "Fax": "37360545",
                    "Website": "http://www.jabil.com/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 718.625, 448.0625 ],
                        [ 721.875, 448.3125 ],
                        [ 756.125, 424.6875 ],
                        [ 756.25, 421.8125 ],
                        [ 749.75, 417.1875 ],
                        [ 745.5, 409.8125 ],
                        [ 741.75, 396.3125 ],
                        [ 694.125, 429.3125 ],
                        [ 718.625, 448.0625 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "I-8-2",
            "properties": {
                "name": "I-8-2",
                "gateway": [679.40625,418.75],
                "data": {
                    "ID": 9,
                    "TenDoanhNghiep": "Công ty Cổ phần Sanofi Việt Nam",
                    "GoiTat": "Sanofi Vietnam",
                    "QuocGia": "Singapore",
                    "DaiDienPhapLuat": "Ông Cyril Grandchamp–Desraux - Chủ tịch",
                    "LinhVucHoatDong": "Công nghệ sinh học",
                    "TenDuAnDauTu": "Nhà Máy Sản xuất Và Trung tâm Nghiên cứu Dược phẩm.",
                    "MucTieuQuyMoDuAn": [
                        "a) Mục tiêu:",
                        "- Xây dựng trung tâm  nghiên cứu duy nhất của Tập đoàn Sanofi tại Đông Nam Á để nghiên cứu và phát triển các sản phẩm dược phẩm, mỹ phẩm, các sản phẩm chăm sóc sức khỏe và thực phẩm chức năng chất lượng cao, mới cho thị trường nội địa và khu vực châu Á. Hoạt động nghiên cứu và phát triển bao gồm: nghiên cứu và phát triển sản phẩm mới, chuyển giao/chuyển nhượng sản phẩm từ Tập đoàn Sanofi sang Việt Nam, phát triển và thẩm định phương pháp kiểm nghiệm mới, hỗ trợ các nhà máy cải thiện công thức, quy trình và xử lý sự cố.",
                        "- Xây dựng nhà máy sản xuất dược phẩm, mỹ phẩm, các sản phẩm chăm sóc sức khỏe và thực phẩm chức năng chất lượng cao đáp ứng nhu cầu chữa trị của bệnh nhân trong nước và xuất khẩu đến các nước châu Á phù hợp với chính sách phát triển ngành công nghiệp dược của Chính phủ Việt Nam. Nhà máy mới được thiết kế hiện đại theo tiêu chuẩn GMP của Tổ chức Y tế Thế giới, tiêu chuẩn môi trường và chất lượng của Tập đoàn Sanofi. Tổ chức sản xuất sẽ được xây dựng trên cơ sở Lean Management (tối ưu hóa thời gian thay đổi, quản lý bằng hình ảnh, tối ưu hóa phân luồng, luôn đúng thời gian, v.v…).",
                        "b) Quy mô:",
                        "- Giai đoạn đầu (2015-2017): năng lực sản xuất dự kiến đạt 36.000.000 sản phẩm/năm.",
                        "- Giai đoạn ổn định (năm 2019): năng lực sản xuất dự kiến đạt 86.000.000 sản phẩm/năm.​"
                    ],
                    "DiaChiTrongKhu": "Lô I-8-2, đường D8",
                    "DienThoai": "38298526",
                    "Fax": "",
                    "Website": "http://www.sanofi.com.vn/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 664.5, 407.375 ],
                        [ 693.75, 429.375 ],
                        [ 741.25, 395.875 ],
                        [ 739.25, 387.375 ],
                        [ 732.5, 376.375 ],
                        [ 719.75, 368.625 ],
                        [ 664.5, 407.375 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "I-9",
            "properties": {
                "name": "I-9",
                "gateway": [519.4375,344],
                "data": {
                    "ID": 38,
                    "TenDoanhNghiep": "Công ty TNHH MTV Emotiv Việt Nam",
                    "GoiTat": "EMOTIV VIETNAM",
                    "QuocGia": "Mỹ",
                    "DaiDienPhapLuat": "Bà Phan Hương Giang - Giám đốc",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Dự án Nghiên cứu, sản xuất Thiết bị đọc điện não đồ đeo tai và các sản phẩm ứng dụng tại Việt Nam",
                    "MucTieuQuyMoDuAn": [
                        "- Nghiên cứu, thiết kế, sản xuất thiết bị tai nghe điện não đồ và các ứng dụng trong lĩnh vực sức khỏe, giải trí, tự động hóa.",
                        "+ Giai đoạn 1 (2014 – 2016): lắp đặt nhà xưởng và gia công sản phẩm Emotiv EEG để xuất khẩu.",
                        "+ Giai đoạn 2 (2016 – 2018): đầu tư mở rộng nhà xưởng, sản xuất Emotiv EEG và Emotiv Insight để xuất khẩu.",
                        "- Quy mô (dự kiến):",
                        "+ Sản phẩm Emotiv EEG: 10.000 chiếc (2018)",
                        "+ Sản phẩm Emotiv Insight: 40.000 chiếc (2018)"
                    ],
                    "DiaChiTrongKhu": "Lô I-9",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 514.875, 340.5 ],
                        [ 528.375, 325.25 ],
                        [ 542.625, 336.5 ],
                        [ 527.625, 349.75 ],
                        [ 514.875, 340.5 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "I-9-5",
            "properties": {
                "name": "I-9-5",
                "gateway": [559.59375,383.625],
                "data": {
                    "ID": 33,
                    "TenDoanhNghiep": "Công ty TNHH Mekophar",
                    "GoiTat": "MEKOPHAR BP",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Bà Huỳnh Thị Lan - Chủ tịch",
                    "LinhVucHoatDong": "Công nghệ sinh học",
                    "TenDuAnDauTu": "Dự án Đầu tư Nghiên cứu Phát triển & Sản xuất Sinh - Dược phẩm Mekophar",
                    "MucTieuQuyMoDuAn": [
                        "a) Mục tiêu:",
                        "Xây dựng một cơ sở NC-SX để triển khai NC, phát triển sản phẩm và SX các sinh, dược phẩm bằng CNSH, các loại dược phẩm thế hệ mới, mỹ phẩm, thực phẩm chức năng bằng CN mới, tiên tiến.",
                        "b) Quy mô:",
                        "- Giai đoạn đầu: sản lượng hằng năm: 1.960 mẫu Tế bào gốc; 7.000 sản phẩm chiết tách từ nguồn Plasma; 150 mặt hàng Dược phẩm.",
                        "- Giai đoạn ổn định: sản lượng hằng năm: 9.600 mẫu Tế bào gốc; 15.000 sản phẩm chiết tách từ nguồn Plasma; 200 mặt hàng Dược phẩm."
                    ],
                    "DiaChiTrongKhu": "Lô I-9-5, Đường D2",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "www.mekophar.com",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 562.1875, 386.25 ],
                        [ 565.3125, 387.25 ],
                        [ 592.5625, 376.25 ],
                        [ 584.8125, 365.625 ],
                        [ 556.0625, 379.625 ],
                        [ 562.1875, 386.25 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "I-9-8",
            "properties": {
                "name": "I-9-8",
                "gateway": [595.515625,316.8125],
                "data": {
                    "ID": 48,
                    "TenDoanhNghiep": "Công ty TNHH MTV Nhà máy Công nghệ sinh học và Thiết bị y tế Hoàng Nguyên",
                    "GoiTat": "",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Nguyễn Trọng Hiếu",
                    "LinhVucHoatDong": "Công nghệ sinh học",
                    "TenDuAnDauTu": "Ứng dụng công nghệ Gen trong sản xuất Chip sinh học phục vụ chuẩn đoán và điều trị một số bệnh lý",
                    "MucTieuQuyMoDuAn": [
                        "Sản xuất Biochip chẩn đoán bệnh lao, ung thư, điếc bẩm sinh, bệnh thalassemia với công suất 360.000 chip các loại/năm đạt tiêu chuẩn quốc tế."
                    ],
                    "DiaChiTrongKhu": "Lô I-9-8, Đường D2",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 587.125, 315.1000003814697 ],
                        [ 595.875, 316.8500003814697 ],
                        [ 602.375, 318.3500003814697 ],
                        [ 606.625, 320.6000003814697 ],
                        [ 612.625, 323.6000003814697 ],
                        [ 615.625, 325.1000003814697 ],
                        [ 578.875, 351.3500003814697 ],
                        [ 575.625, 354.1000003814697 ],
                        [ 572.625, 356.3500003814697 ],
                        [ 558.375, 342.6000003814697 ],
                        [ 587.125, 315.1000003814697 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "T3A",
            "properties": {
                "name": "T3A",
                "gateway": [495.8125,338.125],
                "data": {
                    "ID": 56,
                    "TenDoanhNghiep": "Tập đoàn Viễn thông Quân đội (Viettel)",
                    "GoiTat": "Viettel",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Nguyễn Mạnh Hùng - Tổng Giám đốc",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Xây dựng Hạ tầng viễn thông phục vụ Khu Công Nghệ Cao Giai đoạn II, Quận 9, TP.HCM​",
                    "MucTieuQuyMoDuAn": [
                        "a) Mục tiêu:",
                        "Xây dựng hệ thống hạ tầng viễn thông và thông tin liên lạc trên cơ sở công nghệ hiện đại, phục vụ tốt nhất cho các nhiệm vụ điều hành và sản xuất kinh doanh của Khu Công nghệ cao Giai đoạn II – Quận 9 – TP.HCM, tăng vùng phủ và phát triển các dịch vụ gia tăng với mục tiêu đạt được 100% diện tích Khu Công nghệ cao.",
                        "b) Quy mô:",
                        "- Xây dựng ngầm hóa tuyến cống bể: 17,7 km",
                        "- Xây dựng tuyến cáp quang: 35,2 km + Xây dựng trạm phát sóng di động: 14 trạm",
                        "- Xây dựng văn phòng và phòng máy thiết bị trung tâm"
                    ],
                    "DiaChiTrongKhu": "Khu T3, Đường D2",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 502.75, 342.125 ],
                        [ 475.5, 372.625 ],
                        [ 469.5, 368.625 ],
                        [ 464.25, 359.375 ],
                        [ 461, 353.125 ],
                        [ 461.75, 344.125 ],
                        [ 467, 336.375 ],
                        [ 472.5, 333.625 ],
                        [ 478.5, 328.125 ],
                        [ 502.75, 342.125 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "HT-2-1",
            "properties": {
                "name": "HT-2-1",
                "gateway": [
                    382.9375,
                    268.75
                ],
                "data": {
                    "ID": 34,
                    "TenDoanhNghiep": "Công ty TNHH MTV Daeyoung Electronics Vina",
                    "GoiTat": "DaeYoung",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Song Bin",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Sản xuất và kinh doanh linh kiện điện tử và màn hình Led dành cho ngành hàng gia dụng (Tủ lạnh, máy lạnh, máy giặt, v.v)",
                    "MucTieuQuyMoDuAn": [

                    ],
                    "DiaChiTrongKhu": "Lô HT-2-1, Đường D2",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 380.125, 267.5 ],
                        [ 380.125, 265.25 ],
                        [ 399.875, 244.75 ],
                        [ 402.875, 244.25 ],
                        [ 429.875, 257.5 ],
                        [ 434.125, 260.5 ],
                        [ 413.375, 283.5 ],
                        [ 380.125, 267.5 ]
                    ]
                ]
            }
        },

        {
            "type": "Feature",
            "id": "TB",
            "properties": {
                "name": "BT",
                "gateway": [274.65625,210.5625],
                "data": {
                    "ID": 57,
                    "TenDoanhNghiep": "Công ty TNHH MTV Transimex Hi Tech Park Logistics",
                    "GoiTat": "Transimex SHTP Logistics",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Bùi Tuấn Ngọc - Chủ tịch HĐTV",
                    "LinhVucHoatDong": "Dịch vụ thương mại",
                    "TenDuAnDauTu": "Kho Ngoại quan và Dịch vụ Hậu cần Khu Công Nghệ Cao",
                    "MucTieuQuyMoDuAn": [
                        "a) Mục tiêu:",
                        "- Xây dựng khai thác kho ngoại quan và kho bảo thuế, kho CFS, kho lạnh, kho thường, bãi chứa container.",
                        "- Trang bị hệ thống khung kệ chứa hàng 6 tầng, hệ thống camera 24/7. Đạt chất lượng và tiêu chuẩn ISO và WHO-GMP chứa các mặt hàng như: sản phẩm điện tử và các loại hàng cao cấp khác được sản xuất tại Khu Công nghệ cao.",
                        "b) Quy mô:",
                        "- Kho ngoại quan và kho bảo thuế: 12.000 m2;",
                        "- Kho CFS: 15.000 m2;",
                        "- Kho lạnh: 8.000 m2;",
                        "- Kho thường: 10.000 m2;",
                        "- Kho thường: 10.000 m2;"
                    ],
                    "DiaChiTrongKhu": "Lô BT, Đường D2",
                    "DienThoai": "22202888",
                    "Fax": "22202889",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 284.5, 215.125 ],
                        [ 302, 167.625 ],
                        [ 273, 153.375 ],
                        [ 250.5, 138.625 ],
                        [ 236.25, 129.625 ],
                        [ 231.75, 130.125 ],
                        [ 227, 143.125 ],
                        [ 256.5, 159.375 ],
                        [ 230.75, 184.875 ],
                        [ 242.5, 193.375 ],
                        [ 284.5, 215.125 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "HC",
            "properties": {
                "name": "HC",
                "gateway": [227.4375,183.25],
                "data": {
                    "ID": 35,
                    "TenDoanhNghiep": "Công ty TNHH MTV Dịch vụ Phân phối Ryobi (Việt Nam)",
                    "GoiTat": "RYOBI DS VN",
                    "QuocGia": "Nhật Bản",
                    "DaiDienPhapLuat": "Ông Mitsunobu Kojima - Chủ tịch HĐTV",
                    "LinhVucHoatDong": "Dịch vụ thương mại",
                    "TenDuAnDauTu": "Trung Tâm Logistics Khu Công Nghệ Cao Thành Phố Hồ Chí Minh​",
                    "MucTieuQuyMoDuAn": [
                        "a) Mục tiêu:",
                        "Đầu tư và kinh doanh kho lưu trữ và dịch vụ đạt chất lượng phù hợp tiêu chuẩn ISO và các tiêu chuẩn WHO-GMP. Ngoài ra, cài đặt hệ thống quản lý kho hàng tiên tiến.",
                        "b) Quy mô:",
                        "Xây dựng một nhà kho 14.950 m2, bao gồm: kho ngoại quan 6.000 m2, kho kiểm soát nhiệt độ và độ ẩm 3.000 m2, và kho thường 5.950 m2."
                    ],
                    "DiaChiTrongKhu": "Lô HC, Đường D2",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 230.375, 184.875 ],
                        [ 256.625, 159.625 ],
                        [ 226.875, 143 ],
                        [ 214.5, 169.25 ],
                        [ 216.125, 175 ],
                        [ 230.375, 184.875 ]
                    ]
                ]
            }
        },

        {
            "type": "Feature",
            "id": "Công ty TNHH MTV Nghiên cứu và Chế tạo khuôn mẫu độ chính xác cao Viedam",
            "properties": {
                "name": "I4b",
                "gateway": [ 741.78125,550.875],
                "data": {
                    "ID": 53,
                    "TenDoanhNghiep": "Công ty TNHH MTV Nghiên cứu và Chế tạo khuôn mẫu độ chính xác cao Viedam",
                    "GoiTat": "VIEDAM M&R Co., Ltd",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Võ Công Hai - Giám đốc",
                    "LinhVucHoatDong": "Cơ khí chính xác và tự động hóa",
                    "TenDuAnDauTu": "Trung tâm Nghiên cứu Phát triển và Chế tạo khuôn mẫu độ chính xác cao Viedam",
                    "MucTieuQuyMoDuAn": [
                        "a) Mục tiêu:",
                        "- Thành lập Trung tâm NC & ĐT về CN khuôn mẫu có độ chính xác cao và ứng dụng vật liệu mới trong ngành khuôn mẫu ​cho đội ngũ kỹ sư công ty.",
                        "- Thành lập nhầ máy chế tạo khuôn mẫu có độ chính xác cao chuyên chế tác các khuôn có độ phức tạp & kỹ thuật cao phục vụ, hỗ trợ các ngành CNC.",
                        "b) Quy mô: sản xuất 200 khuôn/năm."
                    ],
                    "DiaChiTrongKhu": "Lô I-4B-5.2 Đường N3",
                    "DienThoai": "1283668386",
                    "Fax": "38615164",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 743.5625, 552 ],
                        [ 745.8125, 551.75 ],
                        [ 749.1875, 554.125 ],
                        [ 749.1875, 556.625 ],
                        [ 736.3125, 564.875 ],
                        [ 731.9375, 567.625 ],
                        [ 723.6875, 561.875 ],
                        [ 719.8125, 559 ],
                        [ 737.8125, 545.75 ],
                        [ 739.0625, 546.75 ],
                        [ 739.3125, 548.75 ],
                        [ 743.5625, 552 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "Công ty TNHH Hai TV Năng lượng Bảo Sơn",
            "properties": {
                "name": "I4b",
                "gateway": [704.5390625,557.3125],
                "data": {
                    "ID": 29,
                    "TenDoanhNghiep": "Công ty TNHH Hai TV Năng lượng Bảo Sơn",
                    "GoiTat": "",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Huỳnh Quang Báu",
                    "LinhVucHoatDong": "Năng lượng, vật liệu mới",
                    "TenDuAnDauTu": "Nhà máy sản xuất Pin sạc Lithium-Ion LiFePO4​",
                    "MucTieuQuyMoDuAn": [
                        "- Thành lập nhà máy sx các loại pin Lithium-ion dạng tròn​ (cylindrical cell), dạng hộp (prismatic) và Pin lithium-ion tích hợp sử dụng trong các thiết bị điện, xe đạp và xe hơi điện, điện thoại di động, PVA, máy tích xách tay, UPS, EVs, HEVs theo công nghệ sạch, thân thiện với môi trường, cung cấp cho thị trường trong nước và xuất khẩu.",
                        "- Quy mô:",
                        "+ Giai đoạn đầu (02 năm sau khi xây dựng nhà máy): 20.000 sản phẩm,",
                        "+ Giai đoạn ổn định (04 năm sau khi xây dựng nhà máy): 45.000 sản phẩm."
                    ],
                    "DiaChiTrongKhu": "Lô I4b-1.4 Đường N3",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 719.5625, 559.25 ],
                        [ 713.4375, 553.875 ],
                        [ 708.6875, 555.875 ],
                        [ 704.4375, 557.375 ],
                        [ 700.5625, 558.75 ],
                        [ 705.5625, 563.625 ],
                        [ 708.5625, 564.75 ],
                        [ 719.5625, 559.25 ]
                    ]
                ]
            }
        },

        {
            "type": "Feature",
            "id": "Công ty TNHH MTV Nhà máy United Healthcare",
            "properties": {
                "name": "I4b",
                "gateway": [624.359375,600.84375],
                "data": {
                    "ID": 42,
                    "TenDoanhNghiep": "Công ty TNHH MTV Nhà máy United Healthcare",
                    "GoiTat": "United Healthcare Factory",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Võ Xuân Anh Tuấn - Chủ tịch kiêm Giám đốc",
                    "LinhVucHoatDong": "Công nghệ sinh học",
                    "TenDuAnDauTu": "Nhà máy United Healthcare",
                    "MucTieuQuyMoDuAn": [
                        "a) Mục tiêu: Đầu tư xây dựng nhà máy sx stent mạch vành tại VN theo tiêu chuẩn tiên tiến TG (tiêu chuẩn cũa Mỹ), giá thành phù hợp, thay thế hàng nhập khẩu và hướng đến xuất khẩu.",
                        "b) Quy mô:",
                        "- Giai đoạn I (2014 - 2015): Kế hoạch sản xuất 12.000 đơn vị sản phẩm/năm (lống nong động mạch vàng sử dụng trong tim mạch).",
                        "- Giai đoạn II (2015 - 2062): Kế hoạch sản xuất 47.000 đơn vị/năm​ (ống nong mạch sử dụng trong mạch máu, các loại trang thiết bị và dụng cụ y tế khác)."
                    ],
                    "DiaChiTrongKhu": "Lô I-4b-1.3, Đường N3",
                    "DienThoai": "62644964",
                    "Fax": "62644967",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 621.1875, 603.125 ],
                        [ 628.0625, 598.875 ],
                        [ 651.3125, 620.875 ],
                        [ 643.1875, 626.5 ],
                        [ 621.1875, 603.125 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "Công ty TNHH MTV RKW Lotus Châu Á",
            "properties": {
                "name": "I4b",
                "gateway": [615.640625,606.40625],
                "data": {
                    "ID": 54,
                    "TenDoanhNghiep": "Công ty TNHH MTV RKW Lotus Châu Á",
                    "GoiTat": "RKW Lotus Asia Co., Ltd",
                    "QuocGia": "Singapore",
                    "DaiDienPhapLuat": "Ông Nguyễn Như Khuê - Giám đốc điều hành",
                    "LinhVucHoatDong": "Năng lượng, vật liệu mới",
                    "TenDuAnDauTu": "Trung tâm nghiên cứu, phát triển Công nghệ và Sản xuất màng / sản phẩm từ màng polyolefin (PE/PP)​",
                    "MucTieuQuyMoDuAn": [
                        "Xây dựng một trong những ​nhà máy lớn nhất của tập đoàn RKW SE để nghiên cứu, sản xuất, kinh doanh sản phẩm màng nhựa thoát hơi CNC dùng trong y tế, vệ sinh, công nghiệp đóng gói bao bì bằng chất liệu vải polymer không dệt, hạt nhựa tự phân hủy sinh học và hạt nhựa nano compound nhằm thay thế hàng nhập khẩu với giá thành cạnh tranh, phục vụ cho thị trường trong nước từ 5%-20% tổng sản lượng sản phẩm và xuất khẩu từ 80%-95% tổng sản lượng sản phẩm của nhà máy"
                    ],
                    "DiaChiTrongKhu": "Lô I-4b-4, Đường N3",
                    "DienThoai": "38776470",
                    "Fax": "38761815",
                    "Website": "http://www.rkw-lotus.com/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 614.5625, 610.25 ],
                        [ 615.6875, 606.375 ],
                        [ 620.8125, 603.125 ],
                        [ 643.3125, 626.375 ],
                        [ 635.4375, 631.375 ],
                        [ 614.5625, 610.25 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "Công ty TNHH Datalogic Việt Nam",
            "properties": {
                "name": "I4b",
                "gateway": [610.109375,622.375],
                "data": {
                    "ID": 23,
                    "TenDoanhNghiep": "Công ty TNHH Datalogic Việt Nam",
                    "GoiTat": "Datalogic Vietnam LLC",
                    "QuocGia": "Ý",
                    "DaiDienPhapLuat": "Ông John Bradford West - Tổng Giám đốc",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Công ty TNHH Datalogic Việt Nam​",
                    "MucTieuQuyMoDuAn": [
                        "- Thiết kế và sản xuất các thiết bị thu thập dữ liệu tự động ngoại vi và phần mềm do doanh nghiệp sản xuất (sản phẩm, phụ kiện, linh kiện và các linh kiện được lắp ráp) bao gồm thiết bị đọc mã vạch cầm tay, thiết bị đọc mã vạch gắn cố định và máy tính di động.",
                        "- Cung cấp các dịch vụ sửa chữa có bảo hành và không bảo hành đối với các sản phẩm của Datalogic được sản xuất trong Việt Nam và ngoài Việt Nam bởi một trong những công ty thuộc tập đoàn Datalogic (các công ty thành viên với Datalogic Scanning Việt Nam); Cung cấp dịch vụ nghiên cứu & phát triển (liên quan đến thiết bị thu thập dữ liệu tự động, thiết bị đọc mã vạch cầm tay, thiết bị đọc mã vạch kiểu trình diện, thiết bị đọc mã vạch một mặt, máy quét quang học, máy quét/đo quang học, thiết bị dữ liệu đầu cuối cầm tay, máy tính di động, máy scan RFID, cảm biến đo lường, cảm biến tầm nhìn, cảm biến quang điện, máy đánh dấu sản phẩm bằng tia laze, hệ thống nhận diện vật thể, hệ thống phụ theo dõi vật thể, và hệ thống phụ thực hiện xử lý và loại trừ vật thể cung cấp cho các công ty thành viên với Datalogic Việt Nam); Cung cấp dịch vụ công nghệ thông tin cho các công ty thành viên với Datalogic Việt Nam bao gồm dịch vụ tư vấn liên quan đến việc cài đặt phần cứng máy vi tính, dịch vụ tư vấn phần mềm và hệ thống, dịch vụ phân tích hệ thống, dịch vụ thiết kế hệ thống, dịch vụ lập trình và dịch vụ bảo trì hệ thống.",
                        "- Thực hiện quyền xuất nhập khẩu các bộ phận, sản phẩm, phụ kiện, linh kiện và các linh kiện được lắp ráp có mã HS thuộc nhóm 3403, 3506, 3910, 3919, 3920, 3921, 3923, 3926, 4008, 4016, 4017, 4202, 4415, 4812, 4816, 4819, 4821, 4823, 4907, 4908, 4911, 5603, 5609, 5806, 6202, 6305, 6307, 7006, 7009, 7312, 7318, 7320, 7326, 7410, 7419, 7616, 7907, 8203, 8302, 8310, 8421, 8423, 8424, 8471, 8472, 8473, 8479, 8480, 8501, 8504, 8505, 8506, 8507, 8517, 8518, 8523, 8528, 8529, 8531, 8532, 8533, 8534, 8536, 8537, 8541, 8542, 8543, 8544, 8546, 9002."
                    ],
                    "DiaChiTrongKhu": "Lô I-4b",
                    "DienThoai": "",
                    "Fax": "37308482",
                    "Website": "http://www.datalogic.com/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 616.8125, 631.375 ],
                        [ 610.0625, 626.75 ],
                        [ 614.4375, 611.125 ],
                        [ 627.5625, 623.75 ],
                        [ 616.8125, 631.375 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "Công ty TNHH Giải pháp Điện tử T.C Việt Nam",
            "properties": {
                "name": "I4b",
                "gateway": [
                    609.1875,
                    623.125
                ],
                "data": {
                    "ID": 28,
                    "TenDoanhNghiep": "Công ty TNHH Giải pháp Điện tử T.C Việt Nam",
                    "GoiTat": "T.C Electronics",
                    "QuocGia": "Singapore",
                    "DaiDienPhapLuat": "Ông Huỳnh Quốc Giang - Giám đốc điều hành",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "Công ty TNHH Giải pháp Điện tử T.C Việt Nam​",
                    "MucTieuQuyMoDuAn": [
                        "- Thành lập nhà máy chuyên sản xuất sản phẩm từ CN được Cty TC Electronics Solutions nghiên cứu thiết kế hoặc từ CN được chuyển giao bao gồm hệ thống thiết bị truyền hình độ phân giải cao HD, IPTV với CN tiên tiến nhất trên TG hiện nay dùng cho xuất khẩu (70%​ thị trường Châu Âu, Mỹ và ĐNÁ) và thị trường nội địa (30%) thay thế các sản phẩm hiện nay phải nhập khẩu hoàn toàn.",
                        "- Thực hiện chuyển giao CNC, tiên tiến từ Mỹ, Tây Ban Nha, Nhật Bản vào VN nhẳm sản xuất chế tạo các hệ thống, thiết bị tích hợp và thiết bị đầu cuối truyền hình độ phân giải cao HD-Internet-Điện thoại với năng lực sản xuất hàng năm:",
                        "+ Máy phát HD: 200 bộ.",
                        "+ Bộ điều chế: 1.000 bộ.",
                        "+ Khuếch đại 2 chiều: 50.000 bộ.",
                        "+ Máy thu HDTV: 450.000 bộ."
                    ],
                    "DiaChiTrongKhu": "Lô I4-b-6, Đường N3",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 617.0625, 631.75 ],
                        [ 625.5625, 637.875 ],
                        [ 635.4375, 631.375 ],
                        [ 627.5625, 623.875 ],
                        [ 617.0625, 631.75 ]
                    ]
                ]
            }
        },

        {
            "type": "Feature",
            "id": "I-11",
            "properties": {
                "name": "SAMSUNG",
                "gateway": [367.15625,267.4375],
                "data": {
                    "ID": 37,
                    "TenDoanhNghiep": "Công ty TNHH MTV Điện tử Samsung CE Complex",
                    "GoiTat": "SECC",
                    "QuocGia": "Singapore",
                    "DaiDienPhapLuat": "",
                    "LinhVucHoatDong": "Vi điện tử-CNTT- viễn thông",
                    "TenDuAnDauTu": "",
                    "MucTieuQuyMoDuAn": [

                    ],
                    "DiaChiTrongKhu": "Lô I-11, Đường D2",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 296.625, 231.25 ],
                        [ 199.875, 324.75 ],
                        [ 296.625, 382 ],
                        [ 340.625, 375.5 ],
                        [ 397.875, 367.25 ],
                        [ 412.375, 365.5 ],
                        [ 421.875, 362.75 ],
                        [ 429.125, 358.75 ],
                        [ 433.875, 354.75 ],
                        [ 437.875, 347.5 ],
                        [ 438.875, 342.5 ],
                        [ 438.125, 333.5 ],
                        [ 434.625, 311.5 ],
                        [ 433.125, 303.75 ],
                        [ 309.875, 238.5 ],
                        [ 296.625, 231.25 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "I-14.1",
            "properties": {
                "name": "I-14.1",
                "gateway": [
                    263.1875,
                    382.875
                ],
                "data": {
                    "ID": 14,
                    "TenDoanhNghiep": "Công ty CP kinh doanh Khí hóa lỏng Miền Nam (PV GAS SOUTH)",
                    "GoiTat": "PV GAS SOUNT",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Vũ Quý Hiệu",
                    "LinhVucHoatDong": "Dịch vụ thương mại",
                    "TenDuAnDauTu": "Trạm cung cấp khí CNG SAMSUNG​",
                    "MucTieuQuyMoDuAn": [
                        "Cung cấp khí CNG cho nhà máy Samsung tại Khu Công nghệ cao TP.HCM với công suất dự kiến 37 triệu Nm3/năm​"
                    ],
                    "DiaChiTrongKhu": "Lô I-14.1, Đường D4A",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 249.125, 381.75 ],
                        [ 284.875, 382.5 ],
                        [ 286.125, 382 ],
                        [ 262.625, 368.5 ],
                        [ 249.125, 381.75 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "SHTP_Training",
            "properties": {
                "name": "SHTP_Training",
                "gateway": [
                    115.90625,752.203125
                ],
                "data": {
                    "ID": 77,
                    "TenDoanhNghiep": "Trung tâm đào tạo Khu CNC",
                    "GoiTat": "SHTP Traning",
                    "QuocGia": "Ý",
                    "DaiDienPhapLuat": "Ông Nguyễn Minh Thạnh - Giám đốc",
                    "LinhVucHoatDong": "Đào tạo",
                    "TenDuAnDauTu": "​",
                    "MucTieuQuyMoDuAn": [
                    ],
                    "DiaChiTrongKhu": "Lô E1",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "http://www.shtp-training.edu.vn/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [ [ 95.5625, 779.9375 ], [ 97.5625, 772.4375 ], [ 100.1875, 765.4375 ], [ 102.0625, 762.3125 ], [ 104.0625, 759.9375 ], [ 106.6875, 757.6875 ], [ 110.9375, 755.0625 ], [ 113.5625, 754.0625 ], [ 114.9375, 753.1875 ], [ 115.9375, 750.6875 ], [ 115.3125, 746.6875 ], [ 113.8125, 741.1875 ], [ 111.6875, 736.6875 ], [ 74.9375, 770.8125 ], [ 95.5625, 779.9375 ] ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "Trường Đại học Công nghệ Thành Phố Hồ Chí Minh (Hutech)",
            "properties": {
                "name": "Trường Đại học Công nghệ Thành Phố Hồ Chí Minh (Hutech)",
                "gateway": [
                    52.6875,
                    763.5
                ],
                "data": {
                    "ID": 51,
                    "TenDoanhNghiep": "Trường Đại học Công nghệ Thành Phố Hồ Chí Minh (Hutech)",
                    "GoiTat": "Hutech",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Hồ Đắc Lộc - Hiệu trưởng",
                    "LinhVucHoatDong": "Đào tạo",
                    "TenDuAnDauTu": "Trung tâm Đào tạo Nhân lực chất lượng cao HUTECH (HTC)​​",
                    "MucTieuQuyMoDuAn": [
                        "- Đào tạo, cung cấp nhân lực là công nhân, kỹ thuật viên cho các DN CNC tại TP.HCM và các tỉnh lân cận.",
                        "- Xây dựng hệ thống đào tạo nghề hoàn chỉnh (chương trình đào tạo, CSVC. giảng viên, đánh giá kỹ năng nghề và cung ứng LĐ) theo tiêu chuẩn quốc tế.",
                        "- Góp phần nâng cao chất lượng nhân lực ​có kỹ năng nghề theo tiêu chuẩn khu vực và quốc tế.",
                        "- Đào tạo kiến thức quản lý, đồng hành với các DN KH-CN trong giai đoạn đầu thành lập.",
                        "- Nâng cao năng lực đào tạo và NCKH cho trường ĐH Hutech."
                    ],
                    "DiaChiTrongKhu": "Phân khu đào tạo E1 (khối 15-A, 15-B, 15-C)",
                    "DienThoai": "35121507",
                    "Fax": "35120786",
                    "Website": "http://www.hutech.edu.vn/homepage/",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [ [ 38.9375, 755.5625 ], [ 74.4375, 770.9375 ], [ 90.9375, 755.6875 ], [ 70.1875, 742.0625 ], [ 47.9375, 751.5625 ], [ 41.3125, 753.9375 ], [ 38.9375, 755.5625 ] ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "Trường Đại học Nguyễn Tất Thành",
            "properties": {
                "name": "Trường Đại học Nguyễn Tất Thành",
                "gateway": [

                ],
                "data": {
                    "ID": 52,
                    "TenDoanhNghiep": "Trường Đại học Nguyễn Tất Thành",
                    "GoiTat": "",
                    "QuocGia": "Việt Nam",
                    "DaiDienPhapLuat": "Ông Nguyễn Mạnh Hùng - Hiệu trưởng",
                    "LinhVucHoatDong": "Đào tạo",
                    "TenDuAnDauTu": "Trung Tâm Đào Tạo Công Nghệ Cao Đại Học Nguyễn Tất Thành​​",
                    "MucTieuQuyMoDuAn": [
                        "a) Mục tiêu:",
                        "- Đào tạo nguồn nhân lực chất lượng cao trong các lĩnh vực CNC: CNTT; CNSH; CN vi điện tử và tự động hóa; Cơ khí chính xác; CN vật liệu mới, CN nano;",
                        "- Bồi dưỡng kiến thức và kỹ năng chuyên môn cho đội ngũ cán bộ kỹ thuật, cán bộ quản lý, kỹ thuật viên để đáp ứng yêu cầu công tác tại các doanh nghiệp, đặc biệt các doanh nghiệp trong lĩnh vực CNC;",
                        "- Đào tạo nâng cao trình độ cho đội ngũ cán bộ kỹ thuật và cán bộ quản lý để đáp ứng yêu cầu công tác tại các doanh nghiệp, đặc biệt các doanh nghiệp trong lĩnh vực CNC;",
                        "- Sát hạch, chứng nhận kỹ năng nghề cho kỹ thuật viên theo tiêu chuẩn quốc gia, và tiêu chuẩn quốc tế mà Trường Đại học Nguyễn Tất Thành hiện đang có mối quan hệ hợp tác: Edexcel (Anh Quốc); City & Guilds (Anh Quốc); Đại học Meiho (Đài Loan); Đại học Nanjeon (Đài Loan); Đại học AEU (Malaysia); Tổ chức GTZ (Đức); Tổ chức Koica – Hàn Quốc.",
                        "b) Quy mô:",
                        "- Đào tạo ngắn hạn kỹ năng nghề nghiệp và cập nhật các công nghệ tiên tiến, hiện đại của khu vực và thế giới khoảng 2.000 Cán bộ kỹ thuật và cán bộ quản lý, các giáo viên dạy nghề/năm;",
                        "- Đào tạo dài hạn kỹ thuật viên do các tổ chức giáo dục dạy nghề quốc tế cấp bằng: khoảng 1.200 kỹ thuật viên/năm; - Đào tạo sau đại học lĩnh vực công nghệ cao: 250 thạc sĩ/năm (kể từ năm thứ 3 đi vào hoạt động); 25 tiến sĩ/năm (kể từ năm thứ 5 đi vào hoạt động)."
                    ],
                    "DiaChiTrongKhu": "Phân khu Đào tạo E1A",
                    "DienThoai": "",
                    "Fax": "",
                    "Website": "",
                    "TaiLieuDinhKem": ""
                }
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [ [ 70.3125, 741.9375 ], [ 108.3125, 725.8125 ], [ 111.6875, 736.3125 ], [ 91.1875, 755.6875 ], [ 70.3125, 741.9375 ] ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "DVCC",
            "properties": {
                "name": "DVCC",
                "gateway": [
                    462.125,
                    526.6875
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 462.125, 526.6875 ],
                        [ 470.875, 526.9375 ],
                        [ 475.75, 525.9375 ],
                        [ 482.125, 522.8125 ],
                        [ 484.875, 519.5625 ],
                        [ 487.25, 516.0625 ],
                        [ 510.5, 505.0625 ],
                        [ 509.875, 501.0625 ],
                        [ 508.5, 497.3125 ],
                        [ 506.125, 493.4375 ],
                        [ 494.5, 493.3125 ],
                        [ 480.75, 481.5625 ],
                        [ 446.125, 499.8125 ],
                        [ 445.5, 502.6875 ],
                        [ 454.625, 511.9375 ],
                        [ 459.625, 519.5625 ],
                        [ 462.125, 526.6875 ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "NHA-O",
            "properties": {
                "name": "NHA-O",
                "gateway": [
                    431.5,
                    533
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [ 423.25, 534.625 ],
                        [ 438, 530.625 ],
                        [ 394, 490.125 ],
                        [ 386, 495.125 ],
                        [ 423.25, 534.625 ]
                    ]
                ]
            }
        }

    ]
}
